(() => {
  "use strict";
  function e(e) {
    return (
      null !== e &&
      "object" == typeof e &&
      "constructor" in e &&
      e.constructor === Object
    );
  }
  function t(i, r) {
    void 0 === i && (i = {}),
      void 0 === r && (r = {}),
      Object.keys(r).forEach(function (n) {
        void 0 === i[n]
          ? (i[n] = r[n])
          : e(r[n]) && e(i[n]) && Object.keys(r[n]).length > 0 && t(i[n], r[n]);
      });
  }
  var i = {
    body: {},
    addEventListener: function () {},
    removeEventListener: function () {},
    activeElement: { blur: function () {}, nodeName: "" },
    querySelector: function () {
      return null;
    },
    querySelectorAll: function () {
      return [];
    },
    getElementById: function () {
      return null;
    },
    createEvent: function () {
      return { initEvent: function () {} };
    },
    createElement: function () {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function () {},
        getElementsByTagName: function () {
          return [];
        },
      };
    },
    createElementNS: function () {
      return {};
    },
    importNode: function () {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };
  function r() {
    var e = "undefined" != typeof document ? document : {};
    return t(e, i), e;
  }
  var n = {
    document: i,
    navigator: { userAgent: "" },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: {
      replaceState: function () {},
      pushState: function () {},
      go: function () {},
      back: function () {},
    },
    CustomEvent: function () {
      return this;
    },
    addEventListener: function () {},
    removeEventListener: function () {},
    getComputedStyle: function () {
      return {
        getPropertyValue: function () {
          return "";
        },
      };
    },
    Image: function () {},
    Date: function () {},
    screen: {},
    setTimeout: function () {},
    clearTimeout: function () {},
    matchMedia: function () {
      return {};
    },
    requestAnimationFrame: function (e) {
      return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
    },
    cancelAnimationFrame: function (e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    },
  };
  function a() {
    var e = "undefined" != typeof window ? window : {};
    return t(e, n), e;
  }
  function s(e) {
    return (
      (s = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }),
      s(e)
    );
  }
  function o(e, t) {
    return (
      (o =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        }),
      o(e, t)
    );
  }
  function l(e, t, i) {
    return (
      (l = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Date.prototype.toString.call(
              Reflect.construct(Date, [], function () {})
            ),
            !0
          );
        } catch (e) {
          return !1;
        }
      })()
        ? Reflect.construct
        : function (e, t, i) {
            var r = [null];
            r.push.apply(r, t);
            var n = new (Function.bind.apply(e, r))();
            return i && o(n, i.prototype), n;
          }),
      l.apply(null, arguments)
    );
  }
  function d(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (
      (d = function (e) {
        if (
          null === e ||
          ((i = e), -1 === Function.toString.call(i).indexOf("[native code]"))
        )
          return e;
        var i;
        if ("function" != typeof e)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }
        function r() {
          return l(e, arguments, s(this).constructor);
        }
        return (
          (r.prototype = Object.create(e.prototype, {
            constructor: {
              value: r,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
          o(r, e)
        );
      }),
      d(e)
    );
  }
  var u = (function (e) {
    var t, i;
    function r(t) {
      var i, r, n;
      return (
        (r = (function (e) {
          if (void 0 === e)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return e;
        })((i = e.call.apply(e, [this].concat(t)) || this))),
        (n = r.__proto__),
        Object.defineProperty(r, "__proto__", {
          get: function () {
            return n;
          },
          set: function (e) {
            n.__proto__ = e;
          },
        }),
        i
      );
    }
    return (
      (i = e),
      ((t = r).prototype = Object.create(i.prototype)),
      (t.prototype.constructor = t),
      (t.__proto__ = i),
      r
    );
  })(d(Array));
  function p(e) {
    void 0 === e && (e = []);
    var t = [];
    return (
      e.forEach(function (e) {
        Array.isArray(e) ? t.push.apply(t, p(e)) : t.push(e);
      }),
      t
    );
  }
  function c(e, t) {
    return Array.prototype.filter.call(e, t);
  }
  function v(e, t) {
    var i = a(),
      n = r(),
      s = [];
    if (!t && e instanceof u) return e;
    if (!e) return new u(s);
    if ("string" == typeof e) {
      var o = e.trim();
      if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
        var l = "div";
        0 === o.indexOf("<li") && (l = "ul"),
          0 === o.indexOf("<tr") && (l = "tbody"),
          (0 !== o.indexOf("<td") && 0 !== o.indexOf("<th")) || (l = "tr"),
          0 === o.indexOf("<tbody") && (l = "table"),
          0 === o.indexOf("<option") && (l = "select");
        var d = n.createElement(l);
        d.innerHTML = o;
        for (var p = 0; p < d.childNodes.length; p += 1)
          s.push(d.childNodes[p]);
      } else
        s = (function (e, t) {
          if ("string" != typeof e) return [e];
          for (
            var i = [], r = t.querySelectorAll(e), n = 0;
            n < r.length;
            n += 1
          )
            i.push(r[n]);
          return i;
        })(e.trim(), t || n);
    } else if (e.nodeType || e === i || e === n) s.push(e);
    else if (Array.isArray(e)) {
      if (e instanceof u) return e;
      s = e;
    }
    return new u(
      (function (e) {
        for (var t = [], i = 0; i < e.length; i += 1)
          -1 === t.indexOf(e[i]) && t.push(e[i]);
        return t;
      })(s)
    );
  }
  v.fn = u.prototype;
  var f = "resize scroll".split(" ");
  function h(e) {
    return function () {
      for (var t = arguments.length, i = new Array(t), r = 0; r < t; r++)
        i[r] = arguments[r];
      if (void 0 === i[0]) {
        for (var n = 0; n < this.length; n += 1)
          f.indexOf(e) < 0 &&
            (e in this[n] ? this[n][e]() : v(this[n]).trigger(e));
        return this;
      }
      return this.on.apply(this, [e].concat(i));
    };
  }
  h("click"),
    h("blur"),
    h("focus"),
    h("focusin"),
    h("focusout"),
    h("keyup"),
    h("keydown"),
    h("keypress"),
    h("submit"),
    h("change"),
    h("mousedown"),
    h("mousemove"),
    h("mouseup"),
    h("mouseenter"),
    h("mouseleave"),
    h("mouseout"),
    h("mouseover"),
    h("touchstart"),
    h("touchend"),
    h("touchmove"),
    h("resize"),
    h("scroll");
  var m = {
    addClass: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var r = p(
        t.map(function (e) {
          return e.split(" ");
        })
      );
      return (
        this.forEach(function (e) {
          var t;
          (t = e.classList).add.apply(t, r);
        }),
        this
      );
    },
    removeClass: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var r = p(
        t.map(function (e) {
          return e.split(" ");
        })
      );
      return (
        this.forEach(function (e) {
          var t;
          (t = e.classList).remove.apply(t, r);
        }),
        this
      );
    },
    hasClass: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var r = p(
        t.map(function (e) {
          return e.split(" ");
        })
      );
      return (
        c(this, function (e) {
          return (
            r.filter(function (t) {
              return e.classList.contains(t);
            }).length > 0
          );
        }).length > 0
      );
    },
    toggleClass: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var r = p(
        t.map(function (e) {
          return e.split(" ");
        })
      );
      this.forEach(function (e) {
        r.forEach(function (t) {
          e.classList.toggle(t);
        });
      });
    },
    attr: function (e, t) {
      if (1 === arguments.length && "string" == typeof e)
        return this[0] ? this[0].getAttribute(e) : void 0;
      for (var i = 0; i < this.length; i += 1)
        if (2 === arguments.length) this[i].setAttribute(e, t);
        else
          for (var r in e) (this[i][r] = e[r]), this[i].setAttribute(r, e[r]);
      return this;
    },
    removeAttr: function (e) {
      for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
      return this;
    },
    transform: function (e) {
      for (var t = 0; t < this.length; t += 1) this[t].style.transform = e;
      return this;
    },
    transition: function (e) {
      for (var t = 0; t < this.length; t += 1)
        this[t].style.transitionDuration = "string" != typeof e ? e + "ms" : e;
      return this;
    },
    on: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var r = t[0],
        n = t[1],
        a = t[2],
        s = t[3];
      function o(e) {
        var t = e.target;
        if (t) {
          var i = e.target.dom7EventData || [];
          if ((i.indexOf(e) < 0 && i.unshift(e), v(t).is(n))) a.apply(t, i);
          else
            for (var r = v(t).parents(), s = 0; s < r.length; s += 1)
              v(r[s]).is(n) && a.apply(r[s], i);
        }
      }
      function l(e) {
        var t = (e && e.target && e.target.dom7EventData) || [];
        t.indexOf(e) < 0 && t.unshift(e), a.apply(this, t);
      }
      "function" == typeof t[1] &&
        ((r = t[0]), (a = t[1]), (s = t[2]), (n = void 0)),
        s || (s = !1);
      for (var d, u = r.split(" "), p = 0; p < this.length; p += 1) {
        var c = this[p];
        if (n)
          for (d = 0; d < u.length; d += 1) {
            var f = u[d];
            c.dom7LiveListeners || (c.dom7LiveListeners = {}),
              c.dom7LiveListeners[f] || (c.dom7LiveListeners[f] = []),
              c.dom7LiveListeners[f].push({ listener: a, proxyListener: o }),
              c.addEventListener(f, o, s);
          }
        else
          for (d = 0; d < u.length; d += 1) {
            var h = u[d];
            c.dom7Listeners || (c.dom7Listeners = {}),
              c.dom7Listeners[h] || (c.dom7Listeners[h] = []),
              c.dom7Listeners[h].push({ listener: a, proxyListener: l }),
              c.addEventListener(h, l, s);
          }
      }
      return this;
    },
    off: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var r = t[0],
        n = t[1],
        a = t[2],
        s = t[3];
      "function" == typeof t[1] &&
        ((r = t[0]), (a = t[1]), (s = t[2]), (n = void 0)),
        s || (s = !1);
      for (var o = r.split(" "), l = 0; l < o.length; l += 1)
        for (var d = o[l], u = 0; u < this.length; u += 1) {
          var p = this[u],
            c = void 0;
          if (
            (!n && p.dom7Listeners
              ? (c = p.dom7Listeners[d])
              : n && p.dom7LiveListeners && (c = p.dom7LiveListeners[d]),
            c && c.length)
          )
            for (var v = c.length - 1; v >= 0; v -= 1) {
              var f = c[v];
              (a && f.listener === a) ||
              (a &&
                f.listener &&
                f.listener.dom7proxy &&
                f.listener.dom7proxy === a)
                ? (p.removeEventListener(d, f.proxyListener, s), c.splice(v, 1))
                : a ||
                  (p.removeEventListener(d, f.proxyListener, s),
                  c.splice(v, 1));
            }
        }
      return this;
    },
    trigger: function () {
      for (
        var e = a(), t = arguments.length, i = new Array(t), r = 0;
        r < t;
        r++
      )
        i[r] = arguments[r];
      for (var n = i[0].split(" "), s = i[1], o = 0; o < n.length; o += 1)
        for (var l = n[o], d = 0; d < this.length; d += 1) {
          var u = this[d];
          if (e.CustomEvent) {
            var p = new e.CustomEvent(l, {
              detail: s,
              bubbles: !0,
              cancelable: !0,
            });
            (u.dom7EventData = i.filter(function (e, t) {
              return t > 0;
            })),
              u.dispatchEvent(p),
              (u.dom7EventData = []),
              delete u.dom7EventData;
          }
        }
      return this;
    },
    transitionEnd: function (e) {
      var t = this;
      return (
        e &&
          t.on("transitionend", function i(r) {
            r.target === this && (e.call(this, r), t.off("transitionend", i));
          }),
        this
      );
    },
    outerWidth: function (e) {
      if (this.length > 0) {
        if (e) {
          var t = this.styles();
          return (
            this[0].offsetWidth +
            parseFloat(t.getPropertyValue("margin-right")) +
            parseFloat(t.getPropertyValue("margin-left"))
          );
        }
        return this[0].offsetWidth;
      }
      return null;
    },
    outerHeight: function (e) {
      if (this.length > 0) {
        if (e) {
          var t = this.styles();
          return (
            this[0].offsetHeight +
            parseFloat(t.getPropertyValue("margin-top")) +
            parseFloat(t.getPropertyValue("margin-bottom"))
          );
        }
        return this[0].offsetHeight;
      }
      return null;
    },
    styles: function () {
      var e = a();
      return this[0] ? e.getComputedStyle(this[0], null) : {};
    },
    offset: function () {
      if (this.length > 0) {
        var e = a(),
          t = r(),
          i = this[0],
          n = i.getBoundingClientRect(),
          s = t.body,
          o = i.clientTop || s.clientTop || 0,
          l = i.clientLeft || s.clientLeft || 0,
          d = i === e ? e.scrollY : i.scrollTop,
          u = i === e ? e.scrollX : i.scrollLeft;
        return { top: n.top + d - o, left: n.left + u - l };
      }
      return null;
    },
    css: function (e, t) {
      var i,
        r = a();
      if (1 === arguments.length) {
        if ("string" != typeof e) {
          for (i = 0; i < this.length; i += 1)
            for (var n in e) this[i].style[n] = e[n];
          return this;
        }
        if (this[0])
          return r.getComputedStyle(this[0], null).getPropertyValue(e);
      }
      if (2 === arguments.length && "string" == typeof e) {
        for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
        return this;
      }
      return this;
    },
    each: function (e) {
      return e
        ? (this.forEach(function (t, i) {
            e.apply(t, [t, i]);
          }),
          this)
        : this;
    },
    html: function (e) {
      if (void 0 === e) return this[0] ? this[0].innerHTML : null;
      for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
      return this;
    },
    text: function (e) {
      if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
      for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
      return this;
    },
    is: function (e) {
      var t,
        i,
        n = a(),
        s = r(),
        o = this[0];
      if (!o || void 0 === e) return !1;
      if ("string" == typeof e) {
        if (o.matches) return o.matches(e);
        if (o.webkitMatchesSelector) return o.webkitMatchesSelector(e);
        if (o.msMatchesSelector) return o.msMatchesSelector(e);
        for (t = v(e), i = 0; i < t.length; i += 1) if (t[i] === o) return !0;
        return !1;
      }
      if (e === s) return o === s;
      if (e === n) return o === n;
      if (e.nodeType || e instanceof u) {
        for (t = e.nodeType ? [e] : e, i = 0; i < t.length; i += 1)
          if (t[i] === o) return !0;
        return !1;
      }
      return !1;
    },
    index: function () {
      var e,
        t = this[0];
      if (t) {
        for (e = 0; null !== (t = t.previousSibling); )
          1 === t.nodeType && (e += 1);
        return e;
      }
    },
    eq: function (e) {
      if (void 0 === e) return this;
      var t = this.length;
      if (e > t - 1) return v([]);
      if (e < 0) {
        var i = t + e;
        return v(i < 0 ? [] : [this[i]]);
      }
      return v([this[e]]);
    },
    append: function () {
      for (var e, t = r(), i = 0; i < arguments.length; i += 1) {
        e = i < 0 || arguments.length <= i ? void 0 : arguments[i];
        for (var n = 0; n < this.length; n += 1)
          if ("string" == typeof e) {
            var a = t.createElement("div");
            for (a.innerHTML = e; a.firstChild; )
              this[n].appendChild(a.firstChild);
          } else if (e instanceof u)
            for (var s = 0; s < e.length; s += 1) this[n].appendChild(e[s]);
          else this[n].appendChild(e);
      }
      return this;
    },
    prepend: function (e) {
      var t,
        i,
        n = r();
      for (t = 0; t < this.length; t += 1)
        if ("string" == typeof e) {
          var a = n.createElement("div");
          for (a.innerHTML = e, i = a.childNodes.length - 1; i >= 0; i -= 1)
            this[t].insertBefore(a.childNodes[i], this[t].childNodes[0]);
        } else if (e instanceof u)
          for (i = 0; i < e.length; i += 1)
            this[t].insertBefore(e[i], this[t].childNodes[0]);
        else this[t].insertBefore(e, this[t].childNodes[0]);
      return this;
    },
    next: function (e) {
      return this.length > 0
        ? e
          ? this[0].nextElementSibling && v(this[0].nextElementSibling).is(e)
            ? v([this[0].nextElementSibling])
            : v([])
          : this[0].nextElementSibling
          ? v([this[0].nextElementSibling])
          : v([])
        : v([]);
    },
    nextAll: function (e) {
      var t = [],
        i = this[0];
      if (!i) return v([]);
      for (; i.nextElementSibling; ) {
        var r = i.nextElementSibling;
        e ? v(r).is(e) && t.push(r) : t.push(r), (i = r);
      }
      return v(t);
    },
    prev: function (e) {
      if (this.length > 0) {
        var t = this[0];
        return e
          ? t.previousElementSibling && v(t.previousElementSibling).is(e)
            ? v([t.previousElementSibling])
            : v([])
          : t.previousElementSibling
          ? v([t.previousElementSibling])
          : v([]);
      }
      return v([]);
    },
    prevAll: function (e) {
      var t = [],
        i = this[0];
      if (!i) return v([]);
      for (; i.previousElementSibling; ) {
        var r = i.previousElementSibling;
        e ? v(r).is(e) && t.push(r) : t.push(r), (i = r);
      }
      return v(t);
    },
    parent: function (e) {
      for (var t = [], i = 0; i < this.length; i += 1)
        null !== this[i].parentNode &&
          (e
            ? v(this[i].parentNode).is(e) && t.push(this[i].parentNode)
            : t.push(this[i].parentNode));
      return v(t);
    },
    parents: function (e) {
      for (var t = [], i = 0; i < this.length; i += 1)
        for (var r = this[i].parentNode; r; )
          e ? v(r).is(e) && t.push(r) : t.push(r), (r = r.parentNode);
      return v(t);
    },
    closest: function (e) {
      var t = this;
      return void 0 === e ? v([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
    },
    find: function (e) {
      for (var t = [], i = 0; i < this.length; i += 1)
        for (var r = this[i].querySelectorAll(e), n = 0; n < r.length; n += 1)
          t.push(r[n]);
      return v(t);
    },
    children: function (e) {
      for (var t = [], i = 0; i < this.length; i += 1)
        for (var r = this[i].children, n = 0; n < r.length; n += 1)
          (e && !v(r[n]).is(e)) || t.push(r[n]);
      return v(t);
    },
    filter: function (e) {
      return v(c(this, e));
    },
    remove: function () {
      for (var e = 0; e < this.length; e += 1)
        this[e].parentNode && this[e].parentNode.removeChild(this[e]);
      return this;
    },
  };
  Object.keys(m).forEach(function (e) {
    Object.defineProperty(v.fn, e, { value: m[e], writable: !0 });
  });
  const g = v;
  function w(e, t) {
    return void 0 === t && (t = 0), setTimeout(e, t);
  }
  function b() {
    return Date.now();
  }
  function y(e) {
    return (
      "object" == typeof e &&
      null !== e &&
      e.constructor &&
      "Object" === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function C() {
    for (
      var e,
        t = Object(arguments.length <= 0 ? void 0 : arguments[0]),
        i = ["__proto__", "constructor", "prototype"],
        r = 1;
      r < arguments.length;
      r += 1
    ) {
      var n = r < 0 || arguments.length <= r ? void 0 : arguments[r];
      if (
        null != n &&
        ((e = n),
        !("undefined" != typeof window && void 0 !== window.HTMLElement
          ? e instanceof HTMLElement
          : e && (1 === e.nodeType || 11 === e.nodeType)))
      )
        for (
          var a = Object.keys(Object(n)).filter(function (e) {
              return i.indexOf(e) < 0;
            }),
            s = 0,
            o = a.length;
          s < o;
          s += 1
        ) {
          var l = a[s],
            d = Object.getOwnPropertyDescriptor(n, l);
          void 0 !== d &&
            d.enumerable &&
            (y(t[l]) && y(n[l])
              ? n[l].__swiper__
                ? (t[l] = n[l])
                : C(t[l], n[l])
              : !y(t[l]) && y(n[l])
              ? ((t[l] = {}), n[l].__swiper__ ? (t[l] = n[l]) : C(t[l], n[l]))
              : (t[l] = n[l]));
        }
    }
    return t;
  }
  function T(e, t) {
    Object.keys(t).forEach(function (i) {
      y(t[i]) &&
        Object.keys(t[i]).forEach(function (r) {
          "function" == typeof t[i][r] && (t[i][r] = t[i][r].bind(e));
        }),
        (e[i] = t[i]);
    });
  }
  function S(e) {
    return (
      void 0 === e && (e = ""),
      "." +
        e
          .trim()
          .replace(/([\.:!\/])/g, "\\$1")
          .replace(/ /g, ".")
    );
  }
  function E(e, t, i, n) {
    var a = r();
    return (
      i &&
        Object.keys(n).forEach(function (i) {
          if (!t[i] && !0 === t.auto) {
            var r = a.createElement("div");
            (r.className = n[i]), e.append(r), (t[i] = r);
          }
        }),
      t
    );
  }
  var x, M, P;
  function k() {
    return (
      x ||
        (x = (function () {
          var e = a(),
            t = r();
          return {
            touch: !!(
              "ontouchstart" in e ||
              (e.DocumentTouch && t instanceof e.DocumentTouch)
            ),
            pointerEvents:
              !!e.PointerEvent &&
              "maxTouchPoints" in e.navigator &&
              e.navigator.maxTouchPoints >= 0,
            observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
            passiveListener: (function () {
              var t = !1;
              try {
                var i = Object.defineProperty({}, "passive", {
                  get: function () {
                    t = !0;
                  },
                });
                e.addEventListener("testPassiveListener", null, i);
              } catch (e) {}
              return t;
            })(),
            gestures: "ongesturestart" in e,
          };
        })()),
      x
    );
  }
  const L = {
    name: "resize",
    create: function () {
      var e = this;
      C(e, {
        resize: {
          observer: null,
          createObserver: function () {
            e &&
              !e.destroyed &&
              e.initialized &&
              ((e.resize.observer = new ResizeObserver(function (t) {
                var i = e.width,
                  r = e.height,
                  n = i,
                  a = r;
                t.forEach(function (t) {
                  var i = t.contentBoxSize,
                    r = t.contentRect,
                    s = t.target;
                  (s && s !== e.el) ||
                    ((n = r ? r.width : (i[0] || i).inlineSize),
                    (a = r ? r.height : (i[0] || i).blockSize));
                }),
                  (n === i && a === r) || e.resize.resizeHandler();
              })),
              e.resize.observer.observe(e.el));
          },
          removeObserver: function () {
            e.resize.observer &&
              e.resize.observer.unobserve &&
              e.el &&
              (e.resize.observer.unobserve(e.el), (e.resize.observer = null));
          },
          resizeHandler: function () {
            e &&
              !e.destroyed &&
              e.initialized &&
              (e.emit("beforeResize"), e.emit("resize"));
          },
          orientationChangeHandler: function () {
            e && !e.destroyed && e.initialized && e.emit("orientationchange");
          },
        },
      });
    },
    on: {
      init: function (e) {
        var t = a();
        e.params.resizeObserver && void 0 !== a().ResizeObserver
          ? e.resize.createObserver()
          : (t.addEventListener("resize", e.resize.resizeHandler),
            t.addEventListener(
              "orientationchange",
              e.resize.orientationChangeHandler
            ));
      },
      destroy: function (e) {
        var t = a();
        e.resize.removeObserver(),
          t.removeEventListener("resize", e.resize.resizeHandler),
          t.removeEventListener(
            "orientationchange",
            e.resize.orientationChangeHandler
          );
      },
    },
  };
  function O() {
    return (
      (O =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var r in i)
              Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
          }
          return e;
        }),
      O.apply(this, arguments)
    );
  }
  var _ = {
    attach: function (e, t) {
      void 0 === t && (t = {});
      var i = a(),
        r = this,
        n = new (i.MutationObserver || i.WebkitMutationObserver)(function (e) {
          if (1 !== e.length) {
            var t = function () {
              r.emit("observerUpdate", e[0]);
            };
            i.requestAnimationFrame
              ? i.requestAnimationFrame(t)
              : i.setTimeout(t, 0);
          } else r.emit("observerUpdate", e[0]);
        });
      n.observe(e, {
        attributes: void 0 === t.attributes || t.attributes,
        childList: void 0 === t.childList || t.childList,
        characterData: void 0 === t.characterData || t.characterData,
      }),
        r.observer.observers.push(n);
    },
    init: function () {
      var e = this;
      if (e.support.observer && e.params.observer) {
        if (e.params.observeParents)
          for (var t = e.$el.parents(), i = 0; i < t.length; i += 1)
            e.observer.attach(t[i]);
        e.observer.attach(e.$el[0], {
          childList: e.params.observeSlideChildren,
        }),
          e.observer.attach(e.$wrapperEl[0], { attributes: !1 });
      }
    },
    destroy: function () {
      this.observer.observers.forEach(function (e) {
        e.disconnect();
      }),
        (this.observer.observers = []);
    },
  };
  const z = {
      name: "observer",
      params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
      create: function () {
        T(this, { observer: O({}, _, { observers: [] }) });
      },
      on: {
        init: function (e) {
          e.observer.init();
        },
        destroy: function (e) {
          e.observer.destroy();
        },
      },
    },
    A = {
      on: function (e, t, i) {
        var r = this;
        if ("function" != typeof t) return r;
        var n = i ? "unshift" : "push";
        return (
          e.split(" ").forEach(function (e) {
            r.eventsListeners[e] || (r.eventsListeners[e] = []),
              r.eventsListeners[e][n](t);
          }),
          r
        );
      },
      once: function (e, t, i) {
        var r = this;
        if ("function" != typeof t) return r;
        function n() {
          r.off(e, n), n.__emitterProxy && delete n.__emitterProxy;
          for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
            a[s] = arguments[s];
          t.apply(r, a);
        }
        return (n.__emitterProxy = t), r.on(e, n, i);
      },
      onAny: function (e, t) {
        var i = this;
        if ("function" != typeof e) return i;
        var r = t ? "unshift" : "push";
        return (
          i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[r](e), i
        );
      },
      offAny: function (e) {
        var t = this;
        if (!t.eventsAnyListeners) return t;
        var i = t.eventsAnyListeners.indexOf(e);
        return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
      },
      off: function (e, t) {
        var i = this;
        return i.eventsListeners
          ? (e.split(" ").forEach(function (e) {
              void 0 === t
                ? (i.eventsListeners[e] = [])
                : i.eventsListeners[e] &&
                  i.eventsListeners[e].forEach(function (r, n) {
                    (r === t || (r.__emitterProxy && r.__emitterProxy === t)) &&
                      i.eventsListeners[e].splice(n, 1);
                  });
            }),
            i)
          : i;
      },
      emit: function () {
        var e,
          t,
          i,
          r = this;
        if (!r.eventsListeners) return r;
        for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
          a[s] = arguments[s];
        return (
          "string" == typeof a[0] || Array.isArray(a[0])
            ? ((e = a[0]), (t = a.slice(1, a.length)), (i = r))
            : ((e = a[0].events), (t = a[0].data), (i = a[0].context || r)),
          t.unshift(i),
          (Array.isArray(e) ? e : e.split(" ")).forEach(function (e) {
            r.eventsAnyListeners &&
              r.eventsAnyListeners.length &&
              r.eventsAnyListeners.forEach(function (r) {
                r.apply(i, [e].concat(t));
              }),
              r.eventsListeners &&
                r.eventsListeners[e] &&
                r.eventsListeners[e].forEach(function (e) {
                  e.apply(i, t);
                });
          }),
          r
        );
      },
    },
    B = {
      updateSize: function () {
        var e,
          t,
          i = this,
          r = i.$el;
        (e =
          void 0 !== i.params.width && null !== i.params.width
            ? i.params.width
            : r[0].clientWidth),
          (t =
            void 0 !== i.params.height && null !== i.params.height
              ? i.params.height
              : r[0].clientHeight),
          (0 === e && i.isHorizontal()) ||
            (0 === t && i.isVertical()) ||
            ((e =
              e -
              parseInt(r.css("padding-left") || 0, 10) -
              parseInt(r.css("padding-right") || 0, 10)),
            (t =
              t -
              parseInt(r.css("padding-top") || 0, 10) -
              parseInt(r.css("padding-bottom") || 0, 10)),
            Number.isNaN(e) && (e = 0),
            Number.isNaN(t) && (t = 0),
            C(i, { width: e, height: t, size: i.isHorizontal() ? e : t }));
      },
      updateSlides: function () {
        var e = this;
        function t(t) {
          return e.isHorizontal()
            ? t
            : {
                width: "height",
                "margin-top": "margin-left",
                "margin-bottom ": "margin-right",
                "margin-left": "margin-top",
                "margin-right": "margin-bottom",
                "padding-left": "padding-top",
                "padding-right": "padding-bottom",
                marginRight: "marginBottom",
              }[t];
        }
        function i(e, i) {
          return parseFloat(e.getPropertyValue(t(i)) || 0);
        }
        var r = e.params,
          n = e.$wrapperEl,
          a = e.size,
          s = e.rtlTranslate,
          o = e.wrongRTL,
          l = e.virtual && r.virtual.enabled,
          d = l ? e.virtual.slides.length : e.slides.length,
          u = n.children("." + e.params.slideClass),
          p = l ? e.virtual.slides.length : u.length,
          c = [],
          v = [],
          f = [],
          h = r.slidesOffsetBefore;
        "function" == typeof h && (h = r.slidesOffsetBefore.call(e));
        var m = r.slidesOffsetAfter;
        "function" == typeof m && (m = r.slidesOffsetAfter.call(e));
        var g = e.snapGrid.length,
          w = e.slidesGrid.length,
          b = r.spaceBetween,
          y = -h,
          T = 0,
          S = 0;
        if (void 0 !== a) {
          var E, x;
          "string" == typeof b &&
            b.indexOf("%") >= 0 &&
            (b = (parseFloat(b.replace("%", "")) / 100) * a),
            (e.virtualSize = -b),
            s
              ? u.css({ marginLeft: "", marginBottom: "", marginTop: "" })
              : u.css({ marginRight: "", marginBottom: "", marginTop: "" }),
            r.slidesPerColumn > 1 &&
              ((E =
                Math.floor(p / r.slidesPerColumn) ===
                p / e.params.slidesPerColumn
                  ? p
                  : Math.ceil(p / r.slidesPerColumn) * r.slidesPerColumn),
              "auto" !== r.slidesPerView &&
                "row" === r.slidesPerColumnFill &&
                (E = Math.max(E, r.slidesPerView * r.slidesPerColumn)));
          for (
            var M,
              P,
              k,
              L = r.slidesPerColumn,
              O = E / L,
              _ = Math.floor(p / r.slidesPerColumn),
              z = 0;
            z < p;
            z += 1
          ) {
            x = 0;
            var A = u.eq(z);
            if (r.slidesPerColumn > 1) {
              var B = void 0,
                I = void 0,
                D = void 0;
              if ("row" === r.slidesPerColumnFill && r.slidesPerGroup > 1) {
                var V = Math.floor(z / (r.slidesPerGroup * r.slidesPerColumn)),
                  G = z - r.slidesPerColumn * r.slidesPerGroup * V,
                  $ =
                    0 === V
                      ? r.slidesPerGroup
                      : Math.min(
                          Math.ceil((p - V * L * r.slidesPerGroup) / L),
                          r.slidesPerGroup
                        );
                (B =
                  (I = G - (D = Math.floor(G / $)) * $ + V * r.slidesPerGroup) +
                  (D * E) / L),
                  A.css({
                    "-webkit-box-ordinal-group": B,
                    "-moz-box-ordinal-group": B,
                    "-ms-flex-order": B,
                    "-webkit-order": B,
                    order: B,
                  });
              } else
                "column" === r.slidesPerColumnFill
                  ? ((D = z - (I = Math.floor(z / L)) * L),
                    (I > _ || (I === _ && D === L - 1)) &&
                      (D += 1) >= L &&
                      ((D = 0), (I += 1)))
                  : (I = z - (D = Math.floor(z / O)) * O);
              A.css(
                t("margin-top"),
                0 !== D ? r.spaceBetween && r.spaceBetween + "px" : ""
              );
            }
            if ("none" !== A.css("display")) {
              if ("auto" === r.slidesPerView) {
                var N = getComputedStyle(A[0]),
                  H = A[0].style.transform,
                  j = A[0].style.webkitTransform;
                if (
                  (H && (A[0].style.transform = "none"),
                  j && (A[0].style.webkitTransform = "none"),
                  r.roundLengths)
                )
                  x = e.isHorizontal() ? A.outerWidth(!0) : A.outerHeight(!0);
                else {
                  var F = i(N, "width"),
                    q = i(N, "padding-left"),
                    R = i(N, "padding-right"),
                    W = i(N, "margin-left"),
                    X = i(N, "margin-right"),
                    Y = N.getPropertyValue("box-sizing");
                  if (Y && "border-box" === Y) x = F + W + X;
                  else {
                    var U = A[0],
                      K = U.clientWidth;
                    x = F + q + R + W + X + (U.offsetWidth - K);
                  }
                }
                H && (A[0].style.transform = H),
                  j && (A[0].style.webkitTransform = j),
                  r.roundLengths && (x = Math.floor(x));
              } else
                (x = (a - (r.slidesPerView - 1) * b) / r.slidesPerView),
                  r.roundLengths && (x = Math.floor(x)),
                  u[z] && (u[z].style[t("width")] = x + "px");
              u[z] && (u[z].swiperSlideSize = x),
                f.push(x),
                r.centeredSlides
                  ? ((y = y + x / 2 + T / 2 + b),
                    0 === T && 0 !== z && (y = y - a / 2 - b),
                    0 === z && (y = y - a / 2 - b),
                    Math.abs(y) < 0.001 && (y = 0),
                    r.roundLengths && (y = Math.floor(y)),
                    S % r.slidesPerGroup == 0 && c.push(y),
                    v.push(y))
                  : (r.roundLengths && (y = Math.floor(y)),
                    (S - Math.min(e.params.slidesPerGroupSkip, S)) %
                      e.params.slidesPerGroup ==
                      0 && c.push(y),
                    v.push(y),
                    (y = y + x + b)),
                (e.virtualSize += x + b),
                (T = x),
                (S += 1);
            }
          }
          if (
            ((e.virtualSize = Math.max(e.virtualSize, a) + m),
            s &&
              o &&
              ("slide" === r.effect || "coverflow" === r.effect) &&
              n.css({ width: e.virtualSize + r.spaceBetween + "px" }),
            r.setWrapperSize &&
              n.css(
                (((P = {})[t("width")] = e.virtualSize + r.spaceBetween + "px"),
                P)
              ),
            r.slidesPerColumn > 1 &&
              ((e.virtualSize = (x + r.spaceBetween) * E),
              (e.virtualSize =
                Math.ceil(e.virtualSize / r.slidesPerColumn) - r.spaceBetween),
              n.css(
                (((k = {})[t("width")] = e.virtualSize + r.spaceBetween + "px"),
                k)
              ),
              r.centeredSlides))
          ) {
            M = [];
            for (var J = 0; J < c.length; J += 1) {
              var Q = c[J];
              r.roundLengths && (Q = Math.floor(Q)),
                c[J] < e.virtualSize + c[0] && M.push(Q);
            }
            c = M;
          }
          if (!r.centeredSlides) {
            M = [];
            for (var Z = 0; Z < c.length; Z += 1) {
              var ee = c[Z];
              r.roundLengths && (ee = Math.floor(ee)),
                c[Z] <= e.virtualSize - a && M.push(ee);
            }
            (c = M),
              Math.floor(e.virtualSize - a) - Math.floor(c[c.length - 1]) > 1 &&
                c.push(e.virtualSize - a);
          }
          if ((0 === c.length && (c = [0]), 0 !== r.spaceBetween)) {
            var te,
              ie = e.isHorizontal() && s ? "marginLeft" : t("marginRight");
            u.filter(function (e, t) {
              return !r.cssMode || t !== u.length - 1;
            }).css((((te = {})[ie] = b + "px"), te));
          }
          if (r.centeredSlides && r.centeredSlidesBounds) {
            var re = 0;
            f.forEach(function (e) {
              re += e + (r.spaceBetween ? r.spaceBetween : 0);
            });
            var ne = (re -= r.spaceBetween) - a;
            c = c.map(function (e) {
              return e < 0 ? -h : e > ne ? ne + m : e;
            });
          }
          if (r.centerInsufficientSlides) {
            var ae = 0;
            if (
              (f.forEach(function (e) {
                ae += e + (r.spaceBetween ? r.spaceBetween : 0);
              }),
              (ae -= r.spaceBetween) < a)
            ) {
              var se = (a - ae) / 2;
              c.forEach(function (e, t) {
                c[t] = e - se;
              }),
                v.forEach(function (e, t) {
                  v[t] = e + se;
                });
            }
          }
          C(e, { slides: u, snapGrid: c, slidesGrid: v, slidesSizesGrid: f }),
            p !== d && e.emit("slidesLengthChange"),
            c.length !== g &&
              (e.params.watchOverflow && e.checkOverflow(),
              e.emit("snapGridLengthChange")),
            v.length !== w && e.emit("slidesGridLengthChange"),
            (r.watchSlidesProgress || r.watchSlidesVisibility) &&
              e.updateSlidesOffset();
        }
      },
      updateAutoHeight: function (e) {
        var t,
          i = this,
          r = [],
          n = i.virtual && i.params.virtual.enabled,
          a = 0;
        "number" == typeof e
          ? i.setTransition(e)
          : !0 === e && i.setTransition(i.params.speed);
        var s = function (e) {
          return n
            ? i.slides.filter(function (t) {
                return (
                  parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e
                );
              })[0]
            : i.slides.eq(e)[0];
        };
        if ("auto" !== i.params.slidesPerView && i.params.slidesPerView > 1)
          if (i.params.centeredSlides)
            i.visibleSlides.each(function (e) {
              r.push(e);
            });
          else
            for (t = 0; t < Math.ceil(i.params.slidesPerView); t += 1) {
              var o = i.activeIndex + t;
              if (o > i.slides.length && !n) break;
              r.push(s(o));
            }
        else r.push(s(i.activeIndex));
        for (t = 0; t < r.length; t += 1)
          if (void 0 !== r[t]) {
            var l = r[t].offsetHeight;
            a = l > a ? l : a;
          }
        a && i.$wrapperEl.css("height", a + "px");
      },
      updateSlidesOffset: function () {
        for (var e = this.slides, t = 0; t < e.length; t += 1)
          e[t].swiperSlideOffset = this.isHorizontal()
            ? e[t].offsetLeft
            : e[t].offsetTop;
      },
      updateSlidesProgress: function (e) {
        void 0 === e && (e = (this && this.translate) || 0);
        var t = this,
          i = t.params,
          r = t.slides,
          n = t.rtlTranslate;
        if (0 !== r.length) {
          void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
          var a = -e;
          n && (a = e),
            r.removeClass(i.slideVisibleClass),
            (t.visibleSlidesIndexes = []),
            (t.visibleSlides = []);
          for (var s = 0; s < r.length; s += 1) {
            var o = r[s],
              l =
                (a +
                  (i.centeredSlides ? t.minTranslate() : 0) -
                  o.swiperSlideOffset) /
                (o.swiperSlideSize + i.spaceBetween);
            if (i.watchSlidesVisibility || (i.centeredSlides && i.autoHeight)) {
              var d = -(a - o.swiperSlideOffset),
                u = d + t.slidesSizesGrid[s];
              ((d >= 0 && d < t.size - 1) ||
                (u > 1 && u <= t.size) ||
                (d <= 0 && u >= t.size)) &&
                (t.visibleSlides.push(o),
                t.visibleSlidesIndexes.push(s),
                r.eq(s).addClass(i.slideVisibleClass));
            }
            o.progress = n ? -l : l;
          }
          t.visibleSlides = g(t.visibleSlides);
        }
      },
      updateProgress: function (e) {
        var t = this;
        if (void 0 === e) {
          var i = t.rtlTranslate ? -1 : 1;
          e = (t && t.translate && t.translate * i) || 0;
        }
        var r = t.params,
          n = t.maxTranslate() - t.minTranslate(),
          a = t.progress,
          s = t.isBeginning,
          o = t.isEnd,
          l = s,
          d = o;
        0 === n
          ? ((a = 0), (s = !0), (o = !0))
          : ((s = (a = (e - t.minTranslate()) / n) <= 0), (o = a >= 1)),
          C(t, { progress: a, isBeginning: s, isEnd: o }),
          (r.watchSlidesProgress ||
            r.watchSlidesVisibility ||
            (r.centeredSlides && r.autoHeight)) &&
            t.updateSlidesProgress(e),
          s && !l && t.emit("reachBeginning toEdge"),
          o && !d && t.emit("reachEnd toEdge"),
          ((l && !s) || (d && !o)) && t.emit("fromEdge"),
          t.emit("progress", a);
      },
      updateSlidesClasses: function () {
        var e,
          t = this,
          i = t.slides,
          r = t.params,
          n = t.$wrapperEl,
          a = t.activeIndex,
          s = t.realIndex,
          o = t.virtual && r.virtual.enabled;
        i.removeClass(
          r.slideActiveClass +
            " " +
            r.slideNextClass +
            " " +
            r.slidePrevClass +
            " " +
            r.slideDuplicateActiveClass +
            " " +
            r.slideDuplicateNextClass +
            " " +
            r.slideDuplicatePrevClass
        ),
          (e = o
            ? t.$wrapperEl.find(
                "." + r.slideClass + '[data-swiper-slide-index="' + a + '"]'
              )
            : i.eq(a)).addClass(r.slideActiveClass),
          r.loop &&
            (e.hasClass(r.slideDuplicateClass)
              ? n
                  .children(
                    "." +
                      r.slideClass +
                      ":not(." +
                      r.slideDuplicateClass +
                      ')[data-swiper-slide-index="' +
                      s +
                      '"]'
                  )
                  .addClass(r.slideDuplicateActiveClass)
              : n
                  .children(
                    "." +
                      r.slideClass +
                      "." +
                      r.slideDuplicateClass +
                      '[data-swiper-slide-index="' +
                      s +
                      '"]'
                  )
                  .addClass(r.slideDuplicateActiveClass));
        var l = e
          .nextAll("." + r.slideClass)
          .eq(0)
          .addClass(r.slideNextClass);
        r.loop && 0 === l.length && (l = i.eq(0)).addClass(r.slideNextClass);
        var d = e
          .prevAll("." + r.slideClass)
          .eq(0)
          .addClass(r.slidePrevClass);
        r.loop && 0 === d.length && (d = i.eq(-1)).addClass(r.slidePrevClass),
          r.loop &&
            (l.hasClass(r.slideDuplicateClass)
              ? n
                  .children(
                    "." +
                      r.slideClass +
                      ":not(." +
                      r.slideDuplicateClass +
                      ')[data-swiper-slide-index="' +
                      l.attr("data-swiper-slide-index") +
                      '"]'
                  )
                  .addClass(r.slideDuplicateNextClass)
              : n
                  .children(
                    "." +
                      r.slideClass +
                      "." +
                      r.slideDuplicateClass +
                      '[data-swiper-slide-index="' +
                      l.attr("data-swiper-slide-index") +
                      '"]'
                  )
                  .addClass(r.slideDuplicateNextClass),
            d.hasClass(r.slideDuplicateClass)
              ? n
                  .children(
                    "." +
                      r.slideClass +
                      ":not(." +
                      r.slideDuplicateClass +
                      ')[data-swiper-slide-index="' +
                      d.attr("data-swiper-slide-index") +
                      '"]'
                  )
                  .addClass(r.slideDuplicatePrevClass)
              : n
                  .children(
                    "." +
                      r.slideClass +
                      "." +
                      r.slideDuplicateClass +
                      '[data-swiper-slide-index="' +
                      d.attr("data-swiper-slide-index") +
                      '"]'
                  )
                  .addClass(r.slideDuplicatePrevClass)),
          t.emitSlidesClasses();
      },
      updateActiveIndex: function (e) {
        var t,
          i = this,
          r = i.rtlTranslate ? i.translate : -i.translate,
          n = i.slidesGrid,
          a = i.snapGrid,
          s = i.params,
          o = i.activeIndex,
          l = i.realIndex,
          d = i.snapIndex,
          u = e;
        if (void 0 === u) {
          for (var p = 0; p < n.length; p += 1)
            void 0 !== n[p + 1]
              ? r >= n[p] && r < n[p + 1] - (n[p + 1] - n[p]) / 2
                ? (u = p)
                : r >= n[p] && r < n[p + 1] && (u = p + 1)
              : r >= n[p] && (u = p);
          s.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
        }
        if (a.indexOf(r) >= 0) t = a.indexOf(r);
        else {
          var c = Math.min(s.slidesPerGroupSkip, u);
          t = c + Math.floor((u - c) / s.slidesPerGroup);
        }
        if ((t >= a.length && (t = a.length - 1), u !== o)) {
          var v = parseInt(
            i.slides.eq(u).attr("data-swiper-slide-index") || u,
            10
          );
          C(i, {
            snapIndex: t,
            realIndex: v,
            previousIndex: o,
            activeIndex: u,
          }),
            i.emit("activeIndexChange"),
            i.emit("snapIndexChange"),
            l !== v && i.emit("realIndexChange"),
            (i.initialized || i.params.runCallbacksOnInit) &&
              i.emit("slideChange");
        } else t !== d && ((i.snapIndex = t), i.emit("snapIndexChange"));
      },
      updateClickedSlide: function (e) {
        var t,
          i = this,
          r = i.params,
          n = g(e.target).closest("." + r.slideClass)[0],
          a = !1;
        if (n)
          for (var s = 0; s < i.slides.length; s += 1)
            if (i.slides[s] === n) {
              (a = !0), (t = s);
              break;
            }
        if (!n || !a)
          return (i.clickedSlide = void 0), void (i.clickedIndex = void 0);
        (i.clickedSlide = n),
          i.virtual && i.params.virtual.enabled
            ? (i.clickedIndex = parseInt(
                g(n).attr("data-swiper-slide-index"),
                10
              ))
            : (i.clickedIndex = t),
          r.slideToClickedSlide &&
            void 0 !== i.clickedIndex &&
            i.clickedIndex !== i.activeIndex &&
            i.slideToClickedSlide();
      },
    },
    I = {
      slideTo: function (e, t, i, r, n) {
        if (
          (void 0 === e && (e = 0),
          void 0 === t && (t = this.params.speed),
          void 0 === i && (i = !0),
          "number" != typeof e && "string" != typeof e)
        )
          throw new Error(
            "The 'index' argument cannot have type other than 'number' or 'string'. [" +
              typeof e +
              "] given."
          );
        if ("string" == typeof e) {
          var a = parseInt(e, 10);
          if (!isFinite(a))
            throw new Error(
              "The passed-in 'index' (string) couldn't be converted to 'number'. [" +
                e +
                "] given."
            );
          e = a;
        }
        var s = this,
          o = e;
        o < 0 && (o = 0);
        var l = s.params,
          d = s.snapGrid,
          u = s.slidesGrid,
          p = s.previousIndex,
          c = s.activeIndex,
          v = s.rtlTranslate,
          f = s.wrapperEl,
          h = s.enabled;
        if (
          (s.animating && l.preventInteractionOnTransition) ||
          (!h && !r && !n)
        )
          return !1;
        var m = Math.min(s.params.slidesPerGroupSkip, o),
          g = m + Math.floor((o - m) / s.params.slidesPerGroup);
        g >= d.length && (g = d.length - 1),
          (c || l.initialSlide || 0) === (p || 0) &&
            i &&
            s.emit("beforeSlideChangeStart");
        var w,
          b = -d[g];
        if ((s.updateProgress(b), l.normalizeSlideIndex))
          for (var y = 0; y < u.length; y += 1) {
            var C = -Math.floor(100 * b),
              T = Math.floor(100 * u[y]),
              S = Math.floor(100 * u[y + 1]);
            void 0 !== u[y + 1]
              ? C >= T && C < S - (S - T) / 2
                ? (o = y)
                : C >= T && C < S && (o = y + 1)
              : C >= T && (o = y);
          }
        if (s.initialized && o !== c) {
          if (!s.allowSlideNext && b < s.translate && b < s.minTranslate())
            return !1;
          if (
            !s.allowSlidePrev &&
            b > s.translate &&
            b > s.maxTranslate() &&
            (c || 0) !== o
          )
            return !1;
        }
        if (
          ((w = o > c ? "next" : o < c ? "prev" : "reset"),
          (v && -b === s.translate) || (!v && b === s.translate))
        )
          return (
            s.updateActiveIndex(o),
            l.autoHeight && s.updateAutoHeight(),
            s.updateSlidesClasses(),
            "slide" !== l.effect && s.setTranslate(b),
            "reset" !== w && (s.transitionStart(i, w), s.transitionEnd(i, w)),
            !1
          );
        if (l.cssMode) {
          var E,
            x = s.isHorizontal(),
            M = -b;
          return (
            v && (M = f.scrollWidth - f.offsetWidth - M),
            0 === t
              ? (f[x ? "scrollLeft" : "scrollTop"] = M)
              : f.scrollTo
              ? f.scrollTo(
                  (((E = {})[x ? "left" : "top"] = M),
                  (E.behavior = "smooth"),
                  E)
                )
              : (f[x ? "scrollLeft" : "scrollTop"] = M),
            !0
          );
        }
        return (
          0 === t
            ? (s.setTransition(0),
              s.setTranslate(b),
              s.updateActiveIndex(o),
              s.updateSlidesClasses(),
              s.emit("beforeTransitionStart", t, r),
              s.transitionStart(i, w),
              s.transitionEnd(i, w))
            : (s.setTransition(t),
              s.setTranslate(b),
              s.updateActiveIndex(o),
              s.updateSlidesClasses(),
              s.emit("beforeTransitionStart", t, r),
              s.transitionStart(i, w),
              s.animating ||
                ((s.animating = !0),
                s.onSlideToWrapperTransitionEnd ||
                  (s.onSlideToWrapperTransitionEnd = function (e) {
                    s &&
                      !s.destroyed &&
                      e.target === this &&
                      (s.$wrapperEl[0].removeEventListener(
                        "transitionend",
                        s.onSlideToWrapperTransitionEnd
                      ),
                      s.$wrapperEl[0].removeEventListener(
                        "webkitTransitionEnd",
                        s.onSlideToWrapperTransitionEnd
                      ),
                      (s.onSlideToWrapperTransitionEnd = null),
                      delete s.onSlideToWrapperTransitionEnd,
                      s.transitionEnd(i, w));
                  }),
                s.$wrapperEl[0].addEventListener(
                  "transitionend",
                  s.onSlideToWrapperTransitionEnd
                ),
                s.$wrapperEl[0].addEventListener(
                  "webkitTransitionEnd",
                  s.onSlideToWrapperTransitionEnd
                ))),
          !0
        );
      },
      slideToLoop: function (e, t, i, r) {
        void 0 === e && (e = 0),
          void 0 === t && (t = this.params.speed),
          void 0 === i && (i = !0);
        var n = this,
          a = e;
        return n.params.loop && (a += n.loopedSlides), n.slideTo(a, t, i, r);
      },
      slideNext: function (e, t, i) {
        void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
        var r = this,
          n = r.params,
          a = r.animating;
        if (!r.enabled) return r;
        var s = r.activeIndex < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup;
        if (n.loop) {
          if (a && n.loopPreventsSlide) return !1;
          r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
        }
        return r.slideTo(r.activeIndex + s, e, t, i);
      },
      slidePrev: function (e, t, i) {
        void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
        var r = this,
          n = r.params,
          a = r.animating,
          s = r.snapGrid,
          o = r.slidesGrid,
          l = r.rtlTranslate;
        if (!r.enabled) return r;
        if (n.loop) {
          if (a && n.loopPreventsSlide) return !1;
          r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
        }
        function d(e) {
          return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
        }
        var u,
          p = d(l ? r.translate : -r.translate),
          c = s.map(function (e) {
            return d(e);
          }),
          v = s[c.indexOf(p) - 1];
        return (
          void 0 === v &&
            n.cssMode &&
            s.forEach(function (e) {
              !v && p >= e && (v = e);
            }),
          void 0 !== v && (u = o.indexOf(v)) < 0 && (u = r.activeIndex - 1),
          r.slideTo(u, e, t, i)
        );
      },
      slideReset: function (e, t, i) {
        return (
          void 0 === e && (e = this.params.speed),
          void 0 === t && (t = !0),
          this.slideTo(this.activeIndex, e, t, i)
        );
      },
      slideToClosest: function (e, t, i, r) {
        void 0 === e && (e = this.params.speed),
          void 0 === t && (t = !0),
          void 0 === r && (r = 0.5);
        var n = this,
          a = n.activeIndex,
          s = Math.min(n.params.slidesPerGroupSkip, a),
          o = s + Math.floor((a - s) / n.params.slidesPerGroup),
          l = n.rtlTranslate ? n.translate : -n.translate;
        if (l >= n.snapGrid[o]) {
          var d = n.snapGrid[o];
          l - d > (n.snapGrid[o + 1] - d) * r && (a += n.params.slidesPerGroup);
        } else {
          var u = n.snapGrid[o - 1];
          l - u <= (n.snapGrid[o] - u) * r && (a -= n.params.slidesPerGroup);
        }
        return (
          (a = Math.max(a, 0)),
          (a = Math.min(a, n.slidesGrid.length - 1)),
          n.slideTo(a, e, t, i)
        );
      },
      slideToClickedSlide: function () {
        var e,
          t = this,
          i = t.params,
          r = t.$wrapperEl,
          n =
            "auto" === i.slidesPerView
              ? t.slidesPerViewDynamic()
              : i.slidesPerView,
          a = t.clickedIndex;
        if (i.loop) {
          if (t.animating) return;
          (e = parseInt(g(t.clickedSlide).attr("data-swiper-slide-index"), 10)),
            i.centeredSlides
              ? a < t.loopedSlides - n / 2 ||
                a > t.slides.length - t.loopedSlides + n / 2
                ? (t.loopFix(),
                  (a = r
                    .children(
                      "." +
                        i.slideClass +
                        '[data-swiper-slide-index="' +
                        e +
                        '"]:not(.' +
                        i.slideDuplicateClass +
                        ")"
                    )
                    .eq(0)
                    .index()),
                  w(function () {
                    t.slideTo(a);
                  }))
                : t.slideTo(a)
              : a > t.slides.length - n
              ? (t.loopFix(),
                (a = r
                  .children(
                    "." +
                      i.slideClass +
                      '[data-swiper-slide-index="' +
                      e +
                      '"]:not(.' +
                      i.slideDuplicateClass +
                      ")"
                  )
                  .eq(0)
                  .index()),
                w(function () {
                  t.slideTo(a);
                }))
              : t.slideTo(a);
        } else t.slideTo(a);
      },
    },
    D = {
      loopCreate: function () {
        var e = this,
          t = r(),
          i = e.params,
          n = e.$wrapperEl;
        n.children("." + i.slideClass + "." + i.slideDuplicateClass).remove();
        var a = n.children("." + i.slideClass);
        if (i.loopFillGroupWithBlank) {
          var s = i.slidesPerGroup - (a.length % i.slidesPerGroup);
          if (s !== i.slidesPerGroup) {
            for (var o = 0; o < s; o += 1) {
              var l = g(t.createElement("div")).addClass(
                i.slideClass + " " + i.slideBlankClass
              );
              n.append(l);
            }
            a = n.children("." + i.slideClass);
          }
        }
        "auto" !== i.slidesPerView ||
          i.loopedSlides ||
          (i.loopedSlides = a.length),
          (e.loopedSlides = Math.ceil(
            parseFloat(i.loopedSlides || i.slidesPerView, 10)
          )),
          (e.loopedSlides += i.loopAdditionalSlides),
          e.loopedSlides > a.length && (e.loopedSlides = a.length);
        var d = [],
          u = [];
        a.each(function (t, i) {
          var r = g(t);
          i < e.loopedSlides && u.push(t),
            i < a.length && i >= a.length - e.loopedSlides && d.push(t),
            r.attr("data-swiper-slide-index", i);
        });
        for (var p = 0; p < u.length; p += 1)
          n.append(g(u[p].cloneNode(!0)).addClass(i.slideDuplicateClass));
        for (var c = d.length - 1; c >= 0; c -= 1)
          n.prepend(g(d[c].cloneNode(!0)).addClass(i.slideDuplicateClass));
      },
      loopFix: function () {
        var e = this;
        e.emit("beforeLoopFix");
        var t,
          i = e.activeIndex,
          r = e.slides,
          n = e.loopedSlides,
          a = e.allowSlidePrev,
          s = e.allowSlideNext,
          o = e.snapGrid,
          l = e.rtlTranslate;
        (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
        var d = -o[i] - e.getTranslate();
        i < n
          ? ((t = r.length - 3 * n + i),
            (t += n),
            e.slideTo(t, 0, !1, !0) &&
              0 !== d &&
              e.setTranslate((l ? -e.translate : e.translate) - d))
          : i >= r.length - n &&
            ((t = -r.length + i + n),
            (t += n),
            e.slideTo(t, 0, !1, !0) &&
              0 !== d &&
              e.setTranslate((l ? -e.translate : e.translate) - d)),
          (e.allowSlidePrev = a),
          (e.allowSlideNext = s),
          e.emit("loopFix");
      },
      loopDestroy: function () {
        var e = this,
          t = e.$wrapperEl,
          i = e.params,
          r = e.slides;
        t
          .children(
            "." +
              i.slideClass +
              "." +
              i.slideDuplicateClass +
              ",." +
              i.slideClass +
              "." +
              i.slideBlankClass
          )
          .remove(),
          r.removeAttr("data-swiper-slide-index");
      },
    };
  function V(e) {
    var t = this,
      i = r(),
      n = a(),
      s = t.touchEventsData,
      o = t.params,
      l = t.touches;
    if (t.enabled && (!t.animating || !o.preventInteractionOnTransition)) {
      var d = e;
      d.originalEvent && (d = d.originalEvent);
      var u = g(d.target);
      if (
        ("wrapper" !== o.touchEventsTarget || u.closest(t.wrapperEl).length) &&
        ((s.isTouchEvent = "touchstart" === d.type),
        (s.isTouchEvent || !("which" in d) || 3 !== d.which) &&
          !(
            (!s.isTouchEvent && "button" in d && d.button > 0) ||
            (s.isTouched && s.isMoved)
          ))
      ) {
        o.noSwipingClass &&
          "" !== o.noSwipingClass &&
          d.target &&
          d.target.shadowRoot &&
          e.path &&
          e.path[0] &&
          (u = g(e.path[0]));
        var p = o.noSwipingSelector
            ? o.noSwipingSelector
            : "." + o.noSwipingClass,
          c = !(!d.target || !d.target.shadowRoot);
        if (
          o.noSwiping &&
          (c
            ? (function (e, t) {
                return (
                  void 0 === t && (t = this),
                  (function t(i) {
                    return i && i !== r() && i !== a()
                      ? (i.assignedSlot && (i = i.assignedSlot),
                        i.closest(e) || t(i.getRootNode().host))
                      : null;
                  })(t)
                );
              })(p, d.target)
            : u.closest(p)[0])
        )
          t.allowClick = !0;
        else if (!o.swipeHandler || u.closest(o.swipeHandler)[0]) {
          (l.currentX =
            "touchstart" === d.type ? d.targetTouches[0].pageX : d.pageX),
            (l.currentY =
              "touchstart" === d.type ? d.targetTouches[0].pageY : d.pageY);
          var v = l.currentX,
            f = l.currentY,
            h = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
            m = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
          if (h && (v <= m || v >= n.innerWidth - m)) {
            if ("prevent" !== h) return;
            e.preventDefault();
          }
          if (
            (C(s, {
              isTouched: !0,
              isMoved: !1,
              allowTouchCallbacks: !0,
              isScrolling: void 0,
              startMoving: void 0,
            }),
            (l.startX = v),
            (l.startY = f),
            (s.touchStartTime = b()),
            (t.allowClick = !0),
            t.updateSize(),
            (t.swipeDirection = void 0),
            o.threshold > 0 && (s.allowThresholdMove = !1),
            "touchstart" !== d.type)
          ) {
            var w = !0;
            u.is(s.focusableElements) && (w = !1),
              i.activeElement &&
                g(i.activeElement).is(s.focusableElements) &&
                i.activeElement !== u[0] &&
                i.activeElement.blur();
            var y = w && t.allowTouchMove && o.touchStartPreventDefault;
            (!o.touchStartForcePreventDefault && !y) ||
              u[0].isContentEditable ||
              d.preventDefault();
          }
          t.emit("touchStart", d);
        }
      }
    }
  }
  function G(e) {
    var t = r(),
      i = this,
      n = i.touchEventsData,
      a = i.params,
      s = i.touches,
      o = i.rtlTranslate;
    if (i.enabled) {
      var l = e;
      if ((l.originalEvent && (l = l.originalEvent), n.isTouched)) {
        if (!n.isTouchEvent || "touchmove" === l.type) {
          var d =
              "touchmove" === l.type &&
              l.targetTouches &&
              (l.targetTouches[0] || l.changedTouches[0]),
            u = "touchmove" === l.type ? d.pageX : l.pageX,
            p = "touchmove" === l.type ? d.pageY : l.pageY;
          if (l.preventedByNestedSwiper)
            return (s.startX = u), void (s.startY = p);
          if (!i.allowTouchMove)
            return (
              (i.allowClick = !1),
              void (
                n.isTouched &&
                (C(s, { startX: u, startY: p, currentX: u, currentY: p }),
                (n.touchStartTime = b()))
              )
            );
          if (n.isTouchEvent && a.touchReleaseOnEdges && !a.loop)
            if (i.isVertical()) {
              if (
                (p < s.startY && i.translate <= i.maxTranslate()) ||
                (p > s.startY && i.translate >= i.minTranslate())
              )
                return (n.isTouched = !1), void (n.isMoved = !1);
            } else if (
              (u < s.startX && i.translate <= i.maxTranslate()) ||
              (u > s.startX && i.translate >= i.minTranslate())
            )
              return;
          if (
            n.isTouchEvent &&
            t.activeElement &&
            l.target === t.activeElement &&
            g(l.target).is(n.focusableElements)
          )
            return (n.isMoved = !0), void (i.allowClick = !1);
          if (
            (n.allowTouchCallbacks && i.emit("touchMove", l),
            !(l.targetTouches && l.targetTouches.length > 1))
          ) {
            (s.currentX = u), (s.currentY = p);
            var c,
              v = s.currentX - s.startX,
              f = s.currentY - s.startY;
            if (
              !(
                i.params.threshold &&
                Math.sqrt(Math.pow(v, 2) + Math.pow(f, 2)) < i.params.threshold
              )
            )
              if (
                (void 0 === n.isScrolling &&
                  ((i.isHorizontal() && s.currentY === s.startY) ||
                  (i.isVertical() && s.currentX === s.startX)
                    ? (n.isScrolling = !1)
                    : v * v + f * f >= 25 &&
                      ((c =
                        (180 * Math.atan2(Math.abs(f), Math.abs(v))) / Math.PI),
                      (n.isScrolling = i.isHorizontal()
                        ? c > a.touchAngle
                        : 90 - c > a.touchAngle))),
                n.isScrolling && i.emit("touchMoveOpposite", l),
                void 0 === n.startMoving &&
                  ((s.currentX === s.startX && s.currentY === s.startY) ||
                    (n.startMoving = !0)),
                n.isScrolling)
              )
                n.isTouched = !1;
              else if (n.startMoving) {
                (i.allowClick = !1),
                  !a.cssMode && l.cancelable && l.preventDefault(),
                  a.touchMoveStopPropagation &&
                    !a.nested &&
                    l.stopPropagation(),
                  n.isMoved ||
                    (a.loop && i.loopFix(),
                    (n.startTranslate = i.getTranslate()),
                    i.setTransition(0),
                    i.animating &&
                      i.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                    (n.allowMomentumBounce = !1),
                    !a.grabCursor ||
                      (!0 !== i.allowSlideNext && !0 !== i.allowSlidePrev) ||
                      i.setGrabCursor(!0),
                    i.emit("sliderFirstMove", l)),
                  i.emit("sliderMove", l),
                  (n.isMoved = !0);
                var h = i.isHorizontal() ? v : f;
                (s.diff = h),
                  (h *= a.touchRatio),
                  o && (h = -h),
                  (i.swipeDirection = h > 0 ? "prev" : "next"),
                  (n.currentTranslate = h + n.startTranslate);
                var m = !0,
                  w = a.resistanceRatio;
                if (
                  (a.touchReleaseOnEdges && (w = 0),
                  h > 0 && n.currentTranslate > i.minTranslate()
                    ? ((m = !1),
                      a.resistance &&
                        (n.currentTranslate =
                          i.minTranslate() -
                          1 +
                          Math.pow(
                            -i.minTranslate() + n.startTranslate + h,
                            w
                          )))
                    : h < 0 &&
                      n.currentTranslate < i.maxTranslate() &&
                      ((m = !1),
                      a.resistance &&
                        (n.currentTranslate =
                          i.maxTranslate() +
                          1 -
                          Math.pow(
                            i.maxTranslate() - n.startTranslate - h,
                            w
                          ))),
                  m && (l.preventedByNestedSwiper = !0),
                  !i.allowSlideNext &&
                    "next" === i.swipeDirection &&
                    n.currentTranslate < n.startTranslate &&
                    (n.currentTranslate = n.startTranslate),
                  !i.allowSlidePrev &&
                    "prev" === i.swipeDirection &&
                    n.currentTranslate > n.startTranslate &&
                    (n.currentTranslate = n.startTranslate),
                  i.allowSlidePrev ||
                    i.allowSlideNext ||
                    (n.currentTranslate = n.startTranslate),
                  a.threshold > 0)
                ) {
                  if (!(Math.abs(h) > a.threshold || n.allowThresholdMove))
                    return void (n.currentTranslate = n.startTranslate);
                  if (!n.allowThresholdMove)
                    return (
                      (n.allowThresholdMove = !0),
                      (s.startX = s.currentX),
                      (s.startY = s.currentY),
                      (n.currentTranslate = n.startTranslate),
                      void (s.diff = i.isHorizontal()
                        ? s.currentX - s.startX
                        : s.currentY - s.startY)
                    );
                }
                a.followFinger &&
                  !a.cssMode &&
                  ((a.freeMode ||
                    a.watchSlidesProgress ||
                    a.watchSlidesVisibility) &&
                    (i.updateActiveIndex(), i.updateSlidesClasses()),
                  a.freeMode &&
                    (0 === n.velocities.length &&
                      n.velocities.push({
                        position: s[i.isHorizontal() ? "startX" : "startY"],
                        time: n.touchStartTime,
                      }),
                    n.velocities.push({
                      position: s[i.isHorizontal() ? "currentX" : "currentY"],
                      time: b(),
                    })),
                  i.updateProgress(n.currentTranslate),
                  i.setTranslate(n.currentTranslate));
              }
          }
        }
      } else n.startMoving && n.isScrolling && i.emit("touchMoveOpposite", l);
    }
  }
  function $(e) {
    var t = this,
      i = t.touchEventsData,
      r = t.params,
      n = t.touches,
      a = t.rtlTranslate,
      s = t.$wrapperEl,
      o = t.slidesGrid,
      l = t.snapGrid;
    if (t.enabled) {
      var d = e;
      if (
        (d.originalEvent && (d = d.originalEvent),
        i.allowTouchCallbacks && t.emit("touchEnd", d),
        (i.allowTouchCallbacks = !1),
        !i.isTouched)
      )
        return (
          i.isMoved && r.grabCursor && t.setGrabCursor(!1),
          (i.isMoved = !1),
          void (i.startMoving = !1)
        );
      r.grabCursor &&
        i.isMoved &&
        i.isTouched &&
        (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
        t.setGrabCursor(!1);
      var u,
        p = b(),
        c = p - i.touchStartTime;
      if (
        (t.allowClick &&
          (t.updateClickedSlide(d),
          t.emit("tap click", d),
          c < 300 &&
            p - i.lastClickTime < 300 &&
            t.emit("doubleTap doubleClick", d)),
        (i.lastClickTime = b()),
        w(function () {
          t.destroyed || (t.allowClick = !0);
        }),
        !i.isTouched ||
          !i.isMoved ||
          !t.swipeDirection ||
          0 === n.diff ||
          i.currentTranslate === i.startTranslate)
      )
        return (i.isTouched = !1), (i.isMoved = !1), void (i.startMoving = !1);
      if (
        ((i.isTouched = !1),
        (i.isMoved = !1),
        (i.startMoving = !1),
        (u = r.followFinger
          ? a
            ? t.translate
            : -t.translate
          : -i.currentTranslate),
        !r.cssMode)
      )
        if (r.freeMode) {
          if (u < -t.minTranslate()) return void t.slideTo(t.activeIndex);
          if (u > -t.maxTranslate())
            return void (t.slides.length < l.length
              ? t.slideTo(l.length - 1)
              : t.slideTo(t.slides.length - 1));
          if (r.freeModeMomentum) {
            if (i.velocities.length > 1) {
              var v = i.velocities.pop(),
                f = i.velocities.pop(),
                h = v.position - f.position,
                m = v.time - f.time;
              (t.velocity = h / m),
                (t.velocity /= 2),
                Math.abs(t.velocity) < r.freeModeMinimumVelocity &&
                  (t.velocity = 0),
                (m > 150 || b() - v.time > 300) && (t.velocity = 0);
            } else t.velocity = 0;
            (t.velocity *= r.freeModeMomentumVelocityRatio),
              (i.velocities.length = 0);
            var g = 1e3 * r.freeModeMomentumRatio,
              y = t.velocity * g,
              C = t.translate + y;
            a && (C = -C);
            var T,
              S,
              E = !1,
              x = 20 * Math.abs(t.velocity) * r.freeModeMomentumBounceRatio;
            if (C < t.maxTranslate())
              r.freeModeMomentumBounce
                ? (C + t.maxTranslate() < -x && (C = t.maxTranslate() - x),
                  (T = t.maxTranslate()),
                  (E = !0),
                  (i.allowMomentumBounce = !0))
                : (C = t.maxTranslate()),
                r.loop && r.centeredSlides && (S = !0);
            else if (C > t.minTranslate())
              r.freeModeMomentumBounce
                ? (C - t.minTranslate() > x && (C = t.minTranslate() + x),
                  (T = t.minTranslate()),
                  (E = !0),
                  (i.allowMomentumBounce = !0))
                : (C = t.minTranslate()),
                r.loop && r.centeredSlides && (S = !0);
            else if (r.freeModeSticky) {
              for (var M, P = 0; P < l.length; P += 1)
                if (l[P] > -C) {
                  M = P;
                  break;
                }
              C = -(C =
                Math.abs(l[M] - C) < Math.abs(l[M - 1] - C) ||
                "next" === t.swipeDirection
                  ? l[M]
                  : l[M - 1]);
            }
            if (
              (S &&
                t.once("transitionEnd", function () {
                  t.loopFix();
                }),
              0 !== t.velocity)
            ) {
              if (
                ((g = a
                  ? Math.abs((-C - t.translate) / t.velocity)
                  : Math.abs((C - t.translate) / t.velocity)),
                r.freeModeSticky)
              ) {
                var k = Math.abs((a ? -C : C) - t.translate),
                  L = t.slidesSizesGrid[t.activeIndex];
                g = k < L ? r.speed : k < 2 * L ? 1.5 * r.speed : 2.5 * r.speed;
              }
            } else if (r.freeModeSticky) return void t.slideToClosest();
            r.freeModeMomentumBounce && E
              ? (t.updateProgress(T),
                t.setTransition(g),
                t.setTranslate(C),
                t.transitionStart(!0, t.swipeDirection),
                (t.animating = !0),
                s.transitionEnd(function () {
                  t &&
                    !t.destroyed &&
                    i.allowMomentumBounce &&
                    (t.emit("momentumBounce"),
                    t.setTransition(r.speed),
                    setTimeout(function () {
                      t.setTranslate(T),
                        s.transitionEnd(function () {
                          t && !t.destroyed && t.transitionEnd();
                        });
                    }, 0));
                }))
              : t.velocity
              ? (t.updateProgress(C),
                t.setTransition(g),
                t.setTranslate(C),
                t.transitionStart(!0, t.swipeDirection),
                t.animating ||
                  ((t.animating = !0),
                  s.transitionEnd(function () {
                    t && !t.destroyed && t.transitionEnd();
                  })))
              : (t.emit("_freeModeNoMomentumRelease"), t.updateProgress(C)),
              t.updateActiveIndex(),
              t.updateSlidesClasses();
          } else {
            if (r.freeModeSticky) return void t.slideToClosest();
            r.freeMode && t.emit("_freeModeNoMomentumRelease");
          }
          (!r.freeModeMomentum || c >= r.longSwipesMs) &&
            (t.updateProgress(),
            t.updateActiveIndex(),
            t.updateSlidesClasses());
        } else {
          for (
            var O = 0, _ = t.slidesSizesGrid[0], z = 0;
            z < o.length;
            z += z < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup
          ) {
            var A = z < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
            void 0 !== o[z + A]
              ? u >= o[z] && u < o[z + A] && ((O = z), (_ = o[z + A] - o[z]))
              : u >= o[z] && ((O = z), (_ = o[o.length - 1] - o[o.length - 2]));
          }
          var B = (u - o[O]) / _,
            I = O < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
          if (c > r.longSwipesMs) {
            if (!r.longSwipes) return void t.slideTo(t.activeIndex);
            "next" === t.swipeDirection &&
              (B >= r.longSwipesRatio ? t.slideTo(O + I) : t.slideTo(O)),
              "prev" === t.swipeDirection &&
                (B > 1 - r.longSwipesRatio ? t.slideTo(O + I) : t.slideTo(O));
          } else {
            if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
            !t.navigation ||
            (d.target !== t.navigation.nextEl &&
              d.target !== t.navigation.prevEl)
              ? ("next" === t.swipeDirection && t.slideTo(O + I),
                "prev" === t.swipeDirection && t.slideTo(O))
              : d.target === t.navigation.nextEl
              ? t.slideTo(O + I)
              : t.slideTo(O);
          }
        }
    }
  }
  function N() {
    var e = this,
      t = e.params,
      i = e.el;
    if (!i || 0 !== i.offsetWidth) {
      t.breakpoints && e.setBreakpoint();
      var r = e.allowSlideNext,
        n = e.allowSlidePrev,
        a = e.snapGrid;
      (e.allowSlideNext = !0),
        (e.allowSlidePrev = !0),
        e.updateSize(),
        e.updateSlides(),
        e.updateSlidesClasses(),
        ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
        e.isEnd &&
        !e.isBeginning &&
        !e.params.centeredSlides
          ? e.slideTo(e.slides.length - 1, 0, !1, !0)
          : e.slideTo(e.activeIndex, 0, !1, !0),
        e.autoplay &&
          e.autoplay.running &&
          e.autoplay.paused &&
          e.autoplay.run(),
        (e.allowSlidePrev = n),
        (e.allowSlideNext = r),
        e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
    }
  }
  function H(e) {
    var t = this;
    t.enabled &&
      (t.allowClick ||
        (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation &&
          t.animating &&
          (e.stopPropagation(), e.stopImmediatePropagation())));
  }
  function j() {
    var e = this,
      t = e.wrapperEl,
      i = e.rtlTranslate;
    if (e.enabled) {
      (e.previousTranslate = e.translate),
        e.isHorizontal()
          ? (e.translate = i
              ? t.scrollWidth - t.offsetWidth - t.scrollLeft
              : -t.scrollLeft)
          : (e.translate = -t.scrollTop),
        -0 === e.translate && (e.translate = 0),
        e.updateActiveIndex(),
        e.updateSlidesClasses();
      var r = e.maxTranslate() - e.minTranslate();
      (0 === r ? 0 : (e.translate - e.minTranslate()) / r) !== e.progress &&
        e.updateProgress(i ? -e.translate : e.translate),
        e.emit("setTranslate", e.translate, !1);
    }
  }
  var F = !1;
  function q() {}
  const R = {
      attachEvents: function () {
        var e = this,
          t = r(),
          i = e.params,
          n = e.touchEvents,
          a = e.el,
          s = e.wrapperEl,
          o = e.device,
          l = e.support;
        (e.onTouchStart = V.bind(e)),
          (e.onTouchMove = G.bind(e)),
          (e.onTouchEnd = $.bind(e)),
          i.cssMode && (e.onScroll = j.bind(e)),
          (e.onClick = H.bind(e));
        var d = !!i.nested;
        if (!l.touch && l.pointerEvents)
          a.addEventListener(n.start, e.onTouchStart, !1),
            t.addEventListener(n.move, e.onTouchMove, d),
            t.addEventListener(n.end, e.onTouchEnd, !1);
        else {
          if (l.touch) {
            var u = !(
              "touchstart" !== n.start ||
              !l.passiveListener ||
              !i.passiveListeners
            ) && { passive: !0, capture: !1 };
            a.addEventListener(n.start, e.onTouchStart, u),
              a.addEventListener(
                n.move,
                e.onTouchMove,
                l.passiveListener ? { passive: !1, capture: d } : d
              ),
              a.addEventListener(n.end, e.onTouchEnd, u),
              n.cancel && a.addEventListener(n.cancel, e.onTouchEnd, u),
              F || (t.addEventListener("touchstart", q), (F = !0));
          }
          ((i.simulateTouch && !o.ios && !o.android) ||
            (i.simulateTouch && !l.touch && o.ios)) &&
            (a.addEventListener("mousedown", e.onTouchStart, !1),
            t.addEventListener("mousemove", e.onTouchMove, d),
            t.addEventListener("mouseup", e.onTouchEnd, !1));
        }
        (i.preventClicks || i.preventClicksPropagation) &&
          a.addEventListener("click", e.onClick, !0),
          i.cssMode && s.addEventListener("scroll", e.onScroll),
          i.updateOnWindowResize
            ? e.on(
                o.ios || o.android
                  ? "resize orientationchange observerUpdate"
                  : "resize observerUpdate",
                N,
                !0
              )
            : e.on("observerUpdate", N, !0);
      },
      detachEvents: function () {
        var e = this,
          t = r(),
          i = e.params,
          n = e.touchEvents,
          a = e.el,
          s = e.wrapperEl,
          o = e.device,
          l = e.support,
          d = !!i.nested;
        if (!l.touch && l.pointerEvents)
          a.removeEventListener(n.start, e.onTouchStart, !1),
            t.removeEventListener(n.move, e.onTouchMove, d),
            t.removeEventListener(n.end, e.onTouchEnd, !1);
        else {
          if (l.touch) {
            var u = !(
              "onTouchStart" !== n.start ||
              !l.passiveListener ||
              !i.passiveListeners
            ) && { passive: !0, capture: !1 };
            a.removeEventListener(n.start, e.onTouchStart, u),
              a.removeEventListener(n.move, e.onTouchMove, d),
              a.removeEventListener(n.end, e.onTouchEnd, u),
              n.cancel && a.removeEventListener(n.cancel, e.onTouchEnd, u);
          }
          ((i.simulateTouch && !o.ios && !o.android) ||
            (i.simulateTouch && !l.touch && o.ios)) &&
            (a.removeEventListener("mousedown", e.onTouchStart, !1),
            t.removeEventListener("mousemove", e.onTouchMove, d),
            t.removeEventListener("mouseup", e.onTouchEnd, !1));
        }
        (i.preventClicks || i.preventClicksPropagation) &&
          a.removeEventListener("click", e.onClick, !0),
          i.cssMode && s.removeEventListener("scroll", e.onScroll),
          e.off(
            o.ios || o.android
              ? "resize orientationchange observerUpdate"
              : "resize observerUpdate",
            N
          );
      },
    },
    W = {
      addClasses: function () {
        var e,
          t,
          i,
          r = this,
          n = r.classNames,
          a = r.params,
          s = r.rtl,
          o = r.$el,
          l = r.device,
          d = r.support,
          u =
            ((e = [
              "initialized",
              a.direction,
              { "pointer-events": d.pointerEvents && !d.touch },
              { "free-mode": a.freeMode },
              { autoheight: a.autoHeight },
              { rtl: s },
              { multirow: a.slidesPerColumn > 1 },
              {
                "multirow-column":
                  a.slidesPerColumn > 1 && "column" === a.slidesPerColumnFill,
              },
              { android: l.android },
              { ios: l.ios },
              { "css-mode": a.cssMode },
            ]),
            (t = a.containerModifierClass),
            (i = []),
            e.forEach(function (e) {
              "object" == typeof e
                ? Object.keys(e).forEach(function (r) {
                    e[r] && i.push(t + r);
                  })
                : "string" == typeof e && i.push(t + e);
            }),
            i);
        n.push.apply(n, u),
          o.addClass([].concat(n).join(" ")),
          r.emitContainerClasses();
      },
      removeClasses: function () {
        var e = this,
          t = e.$el,
          i = e.classNames;
        t.removeClass(i.join(" ")), e.emitContainerClasses();
      },
    },
    X = {
      init: !0,
      direction: "horizontal",
      touchEventsTarget: "container",
      initialSlide: 0,
      speed: 300,
      cssMode: !1,
      updateOnWindowResize: !0,
      resizeObserver: !1,
      nested: !1,
      createElements: !1,
      enabled: !0,
      focusableElements:
        "input, select, option, textarea, button, video, label",
      width: null,
      height: null,
      preventInteractionOnTransition: !1,
      userAgent: null,
      url: null,
      edgeSwipeDetection: !1,
      edgeSwipeThreshold: 20,
      freeMode: !1,
      freeModeMomentum: !0,
      freeModeMomentumRatio: 1,
      freeModeMomentumBounce: !0,
      freeModeMomentumBounceRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeSticky: !1,
      freeModeMinimumVelocity: 0.02,
      autoHeight: !1,
      setWrapperSize: !1,
      virtualTranslate: !1,
      effect: "slide",
      breakpoints: void 0,
      breakpointsBase: "window",
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerColumn: 1,
      slidesPerColumnFill: "column",
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      centeredSlides: !1,
      centeredSlidesBounds: !1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      normalizeSlideIndex: !0,
      centerInsufficientSlides: !1,
      watchOverflow: !1,
      roundLengths: !1,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: !0,
      shortSwipes: !0,
      longSwipes: !0,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: !0,
      allowTouchMove: !0,
      threshold: 0,
      touchMoveStopPropagation: !1,
      touchStartPreventDefault: !0,
      touchStartForcePreventDefault: !1,
      touchReleaseOnEdges: !1,
      uniqueNavElements: !0,
      resistance: !0,
      resistanceRatio: 0.85,
      watchSlidesProgress: !1,
      watchSlidesVisibility: !1,
      grabCursor: !1,
      preventClicks: !0,
      preventClicksPropagation: !0,
      slideToClickedSlide: !1,
      preloadImages: !0,
      updateOnImagesReady: !0,
      loop: !1,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopFillGroupWithBlank: !1,
      loopPreventsSlide: !0,
      allowSlidePrev: !0,
      allowSlideNext: !0,
      swipeHandler: null,
      noSwiping: !0,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,
      passiveListeners: !0,
      containerModifierClass: "swiper-container-",
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-invisible-blank",
      slideActiveClass: "swiper-slide-active",
      slideDuplicateActiveClass: "swiper-slide-duplicate-active",
      slideVisibleClass: "swiper-slide-visible",
      slideDuplicateClass: "swiper-slide-duplicate",
      slideNextClass: "swiper-slide-next",
      slideDuplicateNextClass: "swiper-slide-duplicate-next",
      slidePrevClass: "swiper-slide-prev",
      slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
      wrapperClass: "swiper-wrapper",
      runCallbacksOnInit: !0,
      _emitClasses: !1,
    };
  function Y(e, t) {
    for (var i = 0; i < t.length; i++) {
      var r = t[i];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  var U = {
      modular: {
        useParams: function (e) {
          var t = this;
          t.modules &&
            Object.keys(t.modules).forEach(function (i) {
              var r = t.modules[i];
              r.params && C(e, r.params);
            });
        },
        useModules: function (e) {
          void 0 === e && (e = {});
          var t = this;
          t.modules &&
            Object.keys(t.modules).forEach(function (i) {
              var r = t.modules[i],
                n = e[i] || {};
              r.on &&
                t.on &&
                Object.keys(r.on).forEach(function (e) {
                  t.on(e, r.on[e]);
                }),
                r.create && r.create.bind(t)(n);
            });
        },
      },
      eventsEmitter: A,
      update: B,
      translate: {
        getTranslate: function (e) {
          void 0 === e && (e = this.isHorizontal() ? "x" : "y");
          var t = this,
            i = t.params,
            r = t.rtlTranslate,
            n = t.translate,
            s = t.$wrapperEl;
          if (i.virtualTranslate) return r ? -n : n;
          if (i.cssMode) return n;
          var o = (function (e, t) {
            void 0 === t && (t = "x");
            var i,
              r,
              n,
              s = a(),
              o = (function (e) {
                var t,
                  i = a();
                return (
                  i.getComputedStyle && (t = i.getComputedStyle(e, null)),
                  !t && e.currentStyle && (t = e.currentStyle),
                  t || (t = e.style),
                  t
                );
              })(e);
            return (
              s.WebKitCSSMatrix
                ? ((r = o.transform || o.webkitTransform).split(",").length >
                    6 &&
                    (r = r
                      .split(", ")
                      .map(function (e) {
                        return e.replace(",", ".");
                      })
                      .join(", ")),
                  (n = new s.WebKitCSSMatrix("none" === r ? "" : r)))
                : (i = (n =
                    o.MozTransform ||
                    o.OTransform ||
                    o.MsTransform ||
                    o.msTransform ||
                    o.transform ||
                    o
                      .getPropertyValue("transform")
                      .replace("translate(", "matrix(1, 0, 0, 1,"))
                    .toString()
                    .split(",")),
              "x" === t &&
                (r = s.WebKitCSSMatrix
                  ? n.m41
                  : 16 === i.length
                  ? parseFloat(i[12])
                  : parseFloat(i[4])),
              "y" === t &&
                (r = s.WebKitCSSMatrix
                  ? n.m42
                  : 16 === i.length
                  ? parseFloat(i[13])
                  : parseFloat(i[5])),
              r || 0
            );
          })(s[0], e);
          return r && (o = -o), o || 0;
        },
        setTranslate: function (e, t) {
          var i = this,
            r = i.rtlTranslate,
            n = i.params,
            a = i.$wrapperEl,
            s = i.wrapperEl,
            o = i.progress,
            l = 0,
            d = 0;
          i.isHorizontal() ? (l = r ? -e : e) : (d = e),
            n.roundLengths && ((l = Math.floor(l)), (d = Math.floor(d))),
            n.cssMode
              ? (s[i.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                  i.isHorizontal() ? -l : -d)
              : n.virtualTranslate ||
                a.transform("translate3d(" + l + "px, " + d + "px, 0px)"),
            (i.previousTranslate = i.translate),
            (i.translate = i.isHorizontal() ? l : d);
          var u = i.maxTranslate() - i.minTranslate();
          (0 === u ? 0 : (e - i.minTranslate()) / u) !== o &&
            i.updateProgress(e),
            i.emit("setTranslate", i.translate, t);
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e, t, i, r, n) {
          void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === i && (i = !0),
            void 0 === r && (r = !0);
          var a = this,
            s = a.params,
            o = a.wrapperEl;
          if (a.animating && s.preventInteractionOnTransition) return !1;
          var l,
            d = a.minTranslate(),
            u = a.maxTranslate();
          if (
            ((l = r && e > d ? d : r && e < u ? u : e),
            a.updateProgress(l),
            s.cssMode)
          ) {
            var p,
              c = a.isHorizontal();
            return (
              0 === t
                ? (o[c ? "scrollLeft" : "scrollTop"] = -l)
                : o.scrollTo
                ? o.scrollTo(
                    (((p = {})[c ? "left" : "top"] = -l),
                    (p.behavior = "smooth"),
                    p)
                  )
                : (o[c ? "scrollLeft" : "scrollTop"] = -l),
              !0
            );
          }
          return (
            0 === t
              ? (a.setTransition(0),
                a.setTranslate(l),
                i &&
                  (a.emit("beforeTransitionStart", t, n),
                  a.emit("transitionEnd")))
              : (a.setTransition(t),
                a.setTranslate(l),
                i &&
                  (a.emit("beforeTransitionStart", t, n),
                  a.emit("transitionStart")),
                a.animating ||
                  ((a.animating = !0),
                  a.onTranslateToWrapperTransitionEnd ||
                    (a.onTranslateToWrapperTransitionEnd = function (e) {
                      a &&
                        !a.destroyed &&
                        e.target === this &&
                        (a.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          a.onTranslateToWrapperTransitionEnd
                        ),
                        a.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          a.onTranslateToWrapperTransitionEnd
                        ),
                        (a.onTranslateToWrapperTransitionEnd = null),
                        delete a.onTranslateToWrapperTransitionEnd,
                        i && a.emit("transitionEnd"));
                    }),
                  a.$wrapperEl[0].addEventListener(
                    "transitionend",
                    a.onTranslateToWrapperTransitionEnd
                  ),
                  a.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    a.onTranslateToWrapperTransitionEnd
                  ))),
            !0
          );
        },
      },
      transition: {
        setTransition: function (e, t) {
          var i = this;
          i.params.cssMode || i.$wrapperEl.transition(e),
            i.emit("setTransition", e, t);
        },
        transitionStart: function (e, t) {
          void 0 === e && (e = !0);
          var i = this,
            r = i.activeIndex,
            n = i.params,
            a = i.previousIndex;
          if (!n.cssMode) {
            n.autoHeight && i.updateAutoHeight();
            var s = t;
            if (
              (s || (s = r > a ? "next" : r < a ? "prev" : "reset"),
              i.emit("transitionStart"),
              e && r !== a)
            ) {
              if ("reset" === s)
                return void i.emit("slideResetTransitionStart");
              i.emit("slideChangeTransitionStart"),
                "next" === s
                  ? i.emit("slideNextTransitionStart")
                  : i.emit("slidePrevTransitionStart");
            }
          }
        },
        transitionEnd: function (e, t) {
          void 0 === e && (e = !0);
          var i = this,
            r = i.activeIndex,
            n = i.previousIndex,
            a = i.params;
          if (((i.animating = !1), !a.cssMode)) {
            i.setTransition(0);
            var s = t;
            if (
              (s || (s = r > n ? "next" : r < n ? "prev" : "reset"),
              i.emit("transitionEnd"),
              e && r !== n)
            ) {
              if ("reset" === s) return void i.emit("slideResetTransitionEnd");
              i.emit("slideChangeTransitionEnd"),
                "next" === s
                  ? i.emit("slideNextTransitionEnd")
                  : i.emit("slidePrevTransitionEnd");
            }
          }
        },
      },
      slide: I,
      loop: D,
      grabCursor: {
        setGrabCursor: function (e) {
          var t = this;
          if (
            !(
              t.support.touch ||
              !t.params.simulateTouch ||
              (t.params.watchOverflow && t.isLocked) ||
              t.params.cssMode
            )
          ) {
            var i = t.el;
            (i.style.cursor = "move"),
              (i.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
              (i.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
              (i.style.cursor = e ? "grabbing" : "grab");
          }
        },
        unsetGrabCursor: function () {
          var e = this;
          e.support.touch ||
            (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.el.style.cursor = "");
        },
      },
      manipulation: {
        appendSlide: function (e) {
          var t = this,
            i = t.$wrapperEl,
            r = t.params;
          if (
            (r.loop && t.loopDestroy(), "object" == typeof e && "length" in e)
          )
            for (var n = 0; n < e.length; n += 1) e[n] && i.append(e[n]);
          else i.append(e);
          r.loop && t.loopCreate(),
            (r.observer && t.support.observer) || t.update();
        },
        prependSlide: function (e) {
          var t = this,
            i = t.params,
            r = t.$wrapperEl,
            n = t.activeIndex;
          i.loop && t.loopDestroy();
          var a = n + 1;
          if ("object" == typeof e && "length" in e) {
            for (var s = 0; s < e.length; s += 1) e[s] && r.prepend(e[s]);
            a = n + e.length;
          } else r.prepend(e);
          i.loop && t.loopCreate(),
            (i.observer && t.support.observer) || t.update(),
            t.slideTo(a, 0, !1);
        },
        addSlide: function (e, t) {
          var i = this,
            r = i.$wrapperEl,
            n = i.params,
            a = i.activeIndex;
          n.loop &&
            ((a -= i.loopedSlides),
            i.loopDestroy(),
            (i.slides = r.children("." + n.slideClass)));
          var s = i.slides.length;
          if (e <= 0) i.prependSlide(t);
          else if (e >= s) i.appendSlide(t);
          else {
            for (var o = a > e ? a + 1 : a, l = [], d = s - 1; d >= e; d -= 1) {
              var u = i.slides.eq(d);
              u.remove(), l.unshift(u);
            }
            if ("object" == typeof t && "length" in t) {
              for (var p = 0; p < t.length; p += 1) t[p] && r.append(t[p]);
              o = a > e ? a + t.length : a;
            } else r.append(t);
            for (var c = 0; c < l.length; c += 1) r.append(l[c]);
            n.loop && i.loopCreate(),
              (n.observer && i.support.observer) || i.update(),
              n.loop
                ? i.slideTo(o + i.loopedSlides, 0, !1)
                : i.slideTo(o, 0, !1);
          }
        },
        removeSlide: function (e) {
          var t = this,
            i = t.params,
            r = t.$wrapperEl,
            n = t.activeIndex;
          i.loop &&
            ((n -= t.loopedSlides),
            t.loopDestroy(),
            (t.slides = r.children("." + i.slideClass)));
          var a,
            s = n;
          if ("object" == typeof e && "length" in e) {
            for (var o = 0; o < e.length; o += 1)
              (a = e[o]),
                t.slides[a] && t.slides.eq(a).remove(),
                a < s && (s -= 1);
            s = Math.max(s, 0);
          } else
            (a = e),
              t.slides[a] && t.slides.eq(a).remove(),
              a < s && (s -= 1),
              (s = Math.max(s, 0));
          i.loop && t.loopCreate(),
            (i.observer && t.support.observer) || t.update(),
            i.loop ? t.slideTo(s + t.loopedSlides, 0, !1) : t.slideTo(s, 0, !1);
        },
        removeAllSlides: function () {
          for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
          this.removeSlide(e);
        },
      },
      events: R,
      breakpoints: {
        setBreakpoint: function () {
          var e = this,
            t = e.activeIndex,
            i = e.initialized,
            r = e.loopedSlides,
            n = void 0 === r ? 0 : r,
            a = e.params,
            s = e.$el,
            o = a.breakpoints;
          if (o && (!o || 0 !== Object.keys(o).length)) {
            var l = e.getBreakpoint(o, e.params.breakpointsBase, e.el);
            if (l && e.currentBreakpoint !== l) {
              var d = l in o ? o[l] : void 0;
              d &&
                [
                  "slidesPerView",
                  "spaceBetween",
                  "slidesPerGroup",
                  "slidesPerGroupSkip",
                  "slidesPerColumn",
                ].forEach(function (e) {
                  var t = d[e];
                  void 0 !== t &&
                    (d[e] =
                      "slidesPerView" !== e || ("AUTO" !== t && "auto" !== t)
                        ? "slidesPerView" === e
                          ? parseFloat(t)
                          : parseInt(t, 10)
                        : "auto");
                });
              var u = d || e.originalParams,
                p = a.slidesPerColumn > 1,
                c = u.slidesPerColumn > 1,
                v = a.enabled;
              p && !c
                ? (s.removeClass(
                    a.containerModifierClass +
                      "multirow " +
                      a.containerModifierClass +
                      "multirow-column"
                  ),
                  e.emitContainerClasses())
                : !p &&
                  c &&
                  (s.addClass(a.containerModifierClass + "multirow"),
                  ((u.slidesPerColumnFill &&
                    "column" === u.slidesPerColumnFill) ||
                    (!u.slidesPerColumnFill &&
                      "column" === a.slidesPerColumnFill)) &&
                    s.addClass(a.containerModifierClass + "multirow-column"),
                  e.emitContainerClasses());
              var f = u.direction && u.direction !== a.direction,
                h = a.loop && (u.slidesPerView !== a.slidesPerView || f);
              f && i && e.changeDirection(), C(e.params, u);
              var m = e.params.enabled;
              C(e, {
                allowTouchMove: e.params.allowTouchMove,
                allowSlideNext: e.params.allowSlideNext,
                allowSlidePrev: e.params.allowSlidePrev,
              }),
                v && !m ? e.disable() : !v && m && e.enable(),
                (e.currentBreakpoint = l),
                e.emit("_beforeBreakpoint", u),
                h &&
                  i &&
                  (e.loopDestroy(),
                  e.loopCreate(),
                  e.updateSlides(),
                  e.slideTo(t - n + e.loopedSlides, 0, !1)),
                e.emit("breakpoint", u);
            }
          }
        },
        getBreakpoint: function (e, t, i) {
          if ((void 0 === t && (t = "window"), e && ("container" !== t || i))) {
            var r = !1,
              n = a(),
              s = "window" === t ? n.innerHeight : i.clientHeight,
              o = Object.keys(e).map(function (e) {
                if ("string" == typeof e && 0 === e.indexOf("@")) {
                  var t = parseFloat(e.substr(1));
                  return { value: s * t, point: e };
                }
                return { value: e, point: e };
              });
            o.sort(function (e, t) {
              return parseInt(e.value, 10) - parseInt(t.value, 10);
            });
            for (var l = 0; l < o.length; l += 1) {
              var d = o[l],
                u = d.point,
                p = d.value;
              "window" === t
                ? n.matchMedia("(min-width: " + p + "px)").matches && (r = u)
                : p <= i.clientWidth && (r = u);
            }
            return r || "max";
          }
        },
      },
      checkOverflow: {
        checkOverflow: function () {
          var e = this,
            t = e.params,
            i = e.isLocked,
            r =
              e.slides.length > 0 &&
              t.slidesOffsetBefore +
                t.spaceBetween * (e.slides.length - 1) +
                e.slides[0].offsetWidth * e.slides.length;
          t.slidesOffsetBefore && t.slidesOffsetAfter && r
            ? (e.isLocked = r <= e.size)
            : (e.isLocked = 1 === e.snapGrid.length),
            (e.allowSlideNext = !e.isLocked),
            (e.allowSlidePrev = !e.isLocked),
            i !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
            i &&
              i !== e.isLocked &&
              ((e.isEnd = !1), e.navigation && e.navigation.update());
        },
      },
      classes: W,
      images: {
        loadImage: function (e, t, i, r, n, s) {
          var o,
            l = a();
          function d() {
            s && s();
          }
          g(e).parent("picture")[0] || (e.complete && n)
            ? d()
            : t
            ? (((o = new l.Image()).onload = d),
              (o.onerror = d),
              r && (o.sizes = r),
              i && (o.srcset = i),
              t && (o.src = t))
            : d();
        },
        preloadImages: function () {
          var e = this;
          function t() {
            null != e &&
              e &&
              !e.destroyed &&
              (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
              e.imagesLoaded === e.imagesToLoad.length &&
                (e.params.updateOnImagesReady && e.update(),
                e.emit("imagesReady")));
          }
          e.imagesToLoad = e.$el.find("img");
          for (var i = 0; i < e.imagesToLoad.length; i += 1) {
            var r = e.imagesToLoad[i];
            e.loadImage(
              r,
              r.currentSrc || r.getAttribute("src"),
              r.srcset || r.getAttribute("srcset"),
              r.sizes || r.getAttribute("sizes"),
              !0,
              t
            );
          }
        },
      },
    },
    K = {},
    J = (function () {
      function e() {
        for (
          var t, i, r = arguments.length, n = new Array(r), s = 0;
          s < r;
          s++
        )
          n[s] = arguments[s];
        if (
          (1 === n.length &&
          n[0].constructor &&
          "Object" === Object.prototype.toString.call(n[0]).slice(8, -1)
            ? (i = n[0])
            : ((t = n[0]), (i = n[1])),
          i || (i = {}),
          (i = C({}, i)),
          t && !i.el && (i.el = t),
          i.el && g(i.el).length > 1)
        ) {
          var o = [];
          return (
            g(i.el).each(function (t) {
              var r = C({}, i, { el: t });
              o.push(new e(r));
            }),
            o
          );
        }
        var l,
          d = this;
        (d.__swiper__ = !0),
          (d.support = k()),
          (d.device =
            (void 0 === (l = { userAgent: i.userAgent }) && (l = {}),
            M ||
              (M = (function (e) {
                var t = (void 0 === e ? {} : e).userAgent,
                  i = k(),
                  r = a(),
                  n = r.navigator.platform,
                  s = t || r.navigator.userAgent,
                  o = { ios: !1, android: !1 },
                  l = r.screen.width,
                  d = r.screen.height,
                  u = s.match(/(Android);?[\s\/]+([\d.]+)?/),
                  p = s.match(/(iPad).*OS\s([\d_]+)/),
                  c = s.match(/(iPod)(.*OS\s([\d_]+))?/),
                  v = !p && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                  f = "Win32" === n,
                  h = "MacIntel" === n;
                return (
                  !p &&
                    h &&
                    i.touch &&
                    [
                      "1024x1366",
                      "1366x1024",
                      "834x1194",
                      "1194x834",
                      "834x1112",
                      "1112x834",
                      "768x1024",
                      "1024x768",
                      "820x1180",
                      "1180x820",
                      "810x1080",
                      "1080x810",
                    ].indexOf(l + "x" + d) >= 0 &&
                    ((p = s.match(/(Version)\/([\d.]+)/)) ||
                      (p = [0, 1, "13_0_0"]),
                    (h = !1)),
                  u && !f && ((o.os = "android"), (o.android = !0)),
                  (p || v || c) && ((o.os = "ios"), (o.ios = !0)),
                  o
                );
              })(l)),
            M)),
          (d.browser =
            (P ||
              (P = (function () {
                var e,
                  t = a();
                return {
                  isEdge: !!t.navigator.userAgent.match(/Edge/g),
                  isSafari:
                    ((e = t.navigator.userAgent.toLowerCase()),
                    e.indexOf("safari") >= 0 &&
                      e.indexOf("chrome") < 0 &&
                      e.indexOf("android") < 0),
                  isWebView:
                    /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                      t.navigator.userAgent
                    ),
                };
              })()),
            P)),
          (d.eventsListeners = {}),
          (d.eventsAnyListeners = []),
          void 0 === d.modules && (d.modules = {}),
          Object.keys(d.modules).forEach(function (e) {
            var t = d.modules[e];
            if (t.params) {
              var r = Object.keys(t.params)[0],
                n = t.params[r];
              if ("object" != typeof n || null === n) return;
              if (
                (["navigation", "pagination", "scrollbar"].indexOf(r) >= 0 &&
                  !0 === i[r] &&
                  (i[r] = { auto: !0 }),
                !(r in i) || !("enabled" in n))
              )
                return;
              !0 === i[r] && (i[r] = { enabled: !0 }),
                "object" != typeof i[r] ||
                  "enabled" in i[r] ||
                  (i[r].enabled = !0),
                i[r] || (i[r] = { enabled: !1 });
            }
          });
        var u,
          p,
          c = C({}, X);
        return (
          d.useParams(c),
          (d.params = C({}, c, K, i)),
          (d.originalParams = C({}, d.params)),
          (d.passedParams = C({}, i)),
          d.params &&
            d.params.on &&
            Object.keys(d.params.on).forEach(function (e) {
              d.on(e, d.params.on[e]);
            }),
          d.params && d.params.onAny && d.onAny(d.params.onAny),
          (d.$ = g),
          C(d, {
            enabled: d.params.enabled,
            el: t,
            classNames: [],
            slides: g(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            isHorizontal: function () {
              return "horizontal" === d.params.direction;
            },
            isVertical: function () {
              return "vertical" === d.params.direction;
            },
            activeIndex: 0,
            realIndex: 0,
            isBeginning: !0,
            isEnd: !1,
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: !1,
            allowSlideNext: d.params.allowSlideNext,
            allowSlidePrev: d.params.allowSlidePrev,
            touchEvents:
              ((u = ["touchstart", "touchmove", "touchend", "touchcancel"]),
              (p = ["mousedown", "mousemove", "mouseup"]),
              d.support.pointerEvents &&
                (p = ["pointerdown", "pointermove", "pointerup"]),
              (d.touchEventsTouch = {
                start: u[0],
                move: u[1],
                end: u[2],
                cancel: u[3],
              }),
              (d.touchEventsDesktop = { start: p[0], move: p[1], end: p[2] }),
              d.support.touch || !d.params.simulateTouch
                ? d.touchEventsTouch
                : d.touchEventsDesktop),
            touchEventsData: {
              isTouched: void 0,
              isMoved: void 0,
              allowTouchCallbacks: void 0,
              touchStartTime: void 0,
              isScrolling: void 0,
              currentTranslate: void 0,
              startTranslate: void 0,
              allowThresholdMove: void 0,
              focusableElements: d.params.focusableElements,
              lastClickTime: b(),
              clickTimeout: void 0,
              velocities: [],
              allowMomentumBounce: void 0,
              isTouchEvent: void 0,
              startMoving: void 0,
            },
            allowClick: !0,
            allowTouchMove: d.params.allowTouchMove,
            touches: {
              startX: 0,
              startY: 0,
              currentX: 0,
              currentY: 0,
              diff: 0,
            },
            imagesToLoad: [],
            imagesLoaded: 0,
          }),
          d.useModules(),
          d.emit("_swiper"),
          d.params.init && d.init(),
          d
        );
      }
      var t,
        i,
        n = e.prototype;
      return (
        (n.enable = function () {
          var e = this;
          e.enabled ||
            ((e.enabled = !0),
            e.params.grabCursor && e.setGrabCursor(),
            e.emit("enable"));
        }),
        (n.disable = function () {
          var e = this;
          e.enabled &&
            ((e.enabled = !1),
            e.params.grabCursor && e.unsetGrabCursor(),
            e.emit("disable"));
        }),
        (n.setProgress = function (e, t) {
          var i = this;
          e = Math.min(Math.max(e, 0), 1);
          var r = i.minTranslate(),
            n = (i.maxTranslate() - r) * e + r;
          i.translateTo(n, void 0 === t ? 0 : t),
            i.updateActiveIndex(),
            i.updateSlidesClasses();
        }),
        (n.emitContainerClasses = function () {
          var e = this;
          if (e.params._emitClasses && e.el) {
            var t = e.el.className.split(" ").filter(function (t) {
              return (
                0 === t.indexOf("swiper-container") ||
                0 === t.indexOf(e.params.containerModifierClass)
              );
            });
            e.emit("_containerClasses", t.join(" "));
          }
        }),
        (n.getSlideClasses = function (e) {
          var t = this;
          return e.className
            .split(" ")
            .filter(function (e) {
              return (
                0 === e.indexOf("swiper-slide") ||
                0 === e.indexOf(t.params.slideClass)
              );
            })
            .join(" ");
        }),
        (n.emitSlidesClasses = function () {
          var e = this;
          if (e.params._emitClasses && e.el) {
            var t = [];
            e.slides.each(function (i) {
              var r = e.getSlideClasses(i);
              t.push({ slideEl: i, classNames: r }),
                e.emit("_slideClass", i, r);
            }),
              e.emit("_slideClasses", t);
          }
        }),
        (n.slidesPerViewDynamic = function () {
          var e = this,
            t = e.params,
            i = e.slides,
            r = e.slidesGrid,
            n = e.size,
            a = e.activeIndex,
            s = 1;
          if (t.centeredSlides) {
            for (
              var o, l = i[a].swiperSlideSize, d = a + 1;
              d < i.length;
              d += 1
            )
              i[d] &&
                !o &&
                ((s += 1), (l += i[d].swiperSlideSize) > n && (o = !0));
            for (var u = a - 1; u >= 0; u -= 1)
              i[u] &&
                !o &&
                ((s += 1), (l += i[u].swiperSlideSize) > n && (o = !0));
          } else
            for (var p = a + 1; p < i.length; p += 1)
              r[p] - r[a] < n && (s += 1);
          return s;
        }),
        (n.update = function () {
          var e = this;
          if (e && !e.destroyed) {
            var t = e.snapGrid,
              i = e.params;
            i.breakpoints && e.setBreakpoint(),
              e.updateSize(),
              e.updateSlides(),
              e.updateProgress(),
              e.updateSlidesClasses(),
              e.params.freeMode
                ? (r(), e.params.autoHeight && e.updateAutoHeight())
                : (("auto" === e.params.slidesPerView ||
                    e.params.slidesPerView > 1) &&
                  e.isEnd &&
                  !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0)) || r(),
              i.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
              e.emit("update");
          }
          function r() {
            var t = e.rtlTranslate ? -1 * e.translate : e.translate,
              i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses();
          }
        }),
        (n.changeDirection = function (e, t) {
          void 0 === t && (t = !0);
          var i = this,
            r = i.params.direction;
          return (
            e || (e = "horizontal" === r ? "vertical" : "horizontal"),
            e === r ||
              ("horizontal" !== e && "vertical" !== e) ||
              (i.$el
                .removeClass("" + i.params.containerModifierClass + r)
                .addClass("" + i.params.containerModifierClass + e),
              i.emitContainerClasses(),
              (i.params.direction = e),
              i.slides.each(function (t) {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              i.emit("changeDirection"),
              t && i.update()),
            i
          );
        }),
        (n.mount = function (e) {
          var t = this;
          if (t.mounted) return !0;
          var i = g(e || t.params.el);
          if (!(e = i[0])) return !1;
          e.swiper = t;
          var n = function () {
              return (
                "." + (t.params.wrapperClass || "").trim().split(" ").join(".")
              );
            },
            a = (function () {
              if (e && e.shadowRoot && e.shadowRoot.querySelector) {
                var t = g(e.shadowRoot.querySelector(n()));
                return (
                  (t.children = function (e) {
                    return i.children(e);
                  }),
                  t
                );
              }
              return i.children(n());
            })();
          if (0 === a.length && t.params.createElements) {
            var s = r().createElement("div");
            (a = g(s)),
              (s.className = t.params.wrapperClass),
              i.append(s),
              i.children("." + t.params.slideClass).each(function (e) {
                a.append(e);
              });
          }
          return (
            C(t, {
              $el: i,
              el: e,
              $wrapperEl: a,
              wrapperEl: a[0],
              mounted: !0,
              rtl:
                "rtl" === e.dir.toLowerCase() || "rtl" === i.css("direction"),
              rtlTranslate:
                "horizontal" === t.params.direction &&
                ("rtl" === e.dir.toLowerCase() || "rtl" === i.css("direction")),
              wrongRTL: "-webkit-box" === a.css("display"),
            }),
            !0
          );
        }),
        (n.init = function (e) {
          var t = this;
          return (
            t.initialized ||
              !1 === t.mount(e) ||
              (t.emit("beforeInit"),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(
                    t.params.initialSlide + t.loopedSlides,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  )
                : t.slideTo(
                    t.params.initialSlide,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  ),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit("init"),
              t.emit("afterInit")),
            t
          );
        }),
        (n.destroy = function (e, t) {
          void 0 === e && (e = !0), void 0 === t && (t = !0);
          var i,
            r = this,
            n = r.params,
            a = r.$el,
            s = r.$wrapperEl,
            o = r.slides;
          return (
            void 0 === r.params ||
              r.destroyed ||
              (r.emit("beforeDestroy"),
              (r.initialized = !1),
              r.detachEvents(),
              n.loop && r.loopDestroy(),
              t &&
                (r.removeClasses(),
                a.removeAttr("style"),
                s.removeAttr("style"),
                o &&
                  o.length &&
                  o
                    .removeClass(
                      [
                        n.slideVisibleClass,
                        n.slideActiveClass,
                        n.slideNextClass,
                        n.slidePrevClass,
                      ].join(" ")
                    )
                    .removeAttr("style")
                    .removeAttr("data-swiper-slide-index")),
              r.emit("destroy"),
              Object.keys(r.eventsListeners).forEach(function (e) {
                r.off(e);
              }),
              !1 !== e &&
                ((r.$el[0].swiper = null),
                (i = r),
                Object.keys(i).forEach(function (e) {
                  try {
                    i[e] = null;
                  } catch (e) {}
                  try {
                    delete i[e];
                  } catch (e) {}
                })),
              (r.destroyed = !0)),
            null
          );
        }),
        (e.extendDefaults = function (e) {
          C(K, e);
        }),
        (e.installModule = function (t) {
          e.prototype.modules || (e.prototype.modules = {});
          var i = t.name || Object.keys(e.prototype.modules).length + "_" + b();
          e.prototype.modules[i] = t;
        }),
        (e.use = function (t) {
          return Array.isArray(t)
            ? (t.forEach(function (t) {
                return e.installModule(t);
              }),
              e)
            : (e.installModule(t), e);
        }),
        (t = e),
        (i = [
          {
            key: "extendedDefaults",
            get: function () {
              return K;
            },
          },
          {
            key: "defaults",
            get: function () {
              return X;
            },
          },
        ]),
        null && Y(t.prototype, null),
        i && Y(t, i),
        e
      );
    })();
  Object.keys(U).forEach(function (e) {
    Object.keys(U[e]).forEach(function (t) {
      J.prototype[t] = U[e][t];
    });
  }),
    J.use([L, z]);
  const Q = J;
  function Z() {
    return (
      (Z =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var r in i)
              Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
          }
          return e;
        }),
      Z.apply(this, arguments)
    );
  }
  var ee = {
    toggleEl: function (e, t) {
      e[t ? "addClass" : "removeClass"](this.params.navigation.disabledClass),
        e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = t);
    },
    update: function () {
      var e = this,
        t = e.params.navigation,
        i = e.navigation.toggleEl;
      if (!e.params.loop) {
        var r = e.navigation,
          n = r.$nextEl,
          a = r.$prevEl;
        a &&
          a.length > 0 &&
          (e.isBeginning ? i(a, !0) : i(a, !1),
          e.params.watchOverflow &&
            e.enabled &&
            a[e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
          n &&
            n.length > 0 &&
            (e.isEnd ? i(n, !0) : i(n, !1),
            e.params.watchOverflow &&
              e.enabled &&
              n[e.isLocked ? "addClass" : "removeClass"](t.lockClass));
      }
    },
    onPrevClick: function (e) {
      var t = this;
      e.preventDefault(), (t.isBeginning && !t.params.loop) || t.slidePrev();
    },
    onNextClick: function (e) {
      var t = this;
      e.preventDefault(), (t.isEnd && !t.params.loop) || t.slideNext();
    },
    init: function () {
      var e,
        t,
        i = this,
        r = i.params.navigation;
      (i.params.navigation = E(
        i.$el,
        i.params.navigation,
        i.params.createElements,
        { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
      )),
        (r.nextEl || r.prevEl) &&
          (r.nextEl &&
            ((e = g(r.nextEl)),
            i.params.uniqueNavElements &&
              "string" == typeof r.nextEl &&
              e.length > 1 &&
              1 === i.$el.find(r.nextEl).length &&
              (e = i.$el.find(r.nextEl))),
          r.prevEl &&
            ((t = g(r.prevEl)),
            i.params.uniqueNavElements &&
              "string" == typeof r.prevEl &&
              t.length > 1 &&
              1 === i.$el.find(r.prevEl).length &&
              (t = i.$el.find(r.prevEl))),
          e && e.length > 0 && e.on("click", i.navigation.onNextClick),
          t && t.length > 0 && t.on("click", i.navigation.onPrevClick),
          C(i.navigation, {
            $nextEl: e,
            nextEl: e && e[0],
            $prevEl: t,
            prevEl: t && t[0],
          }),
          i.enabled ||
            (e && e.addClass(r.lockClass), t && t.addClass(r.lockClass)));
    },
    destroy: function () {
      var e = this,
        t = e.navigation,
        i = t.$nextEl,
        r = t.$prevEl;
      i &&
        i.length &&
        (i.off("click", e.navigation.onNextClick),
        i.removeClass(e.params.navigation.disabledClass)),
        r &&
          r.length &&
          (r.off("click", e.navigation.onPrevClick),
          r.removeClass(e.params.navigation.disabledClass));
    },
  };
  const te = {
    name: "navigation",
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: !1,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock",
      },
    },
    create: function () {
      T(this, { navigation: Z({}, ee) });
    },
    on: {
      init: function (e) {
        e.navigation.init(), e.navigation.update();
      },
      toEdge: function (e) {
        e.navigation.update();
      },
      fromEdge: function (e) {
        e.navigation.update();
      },
      destroy: function (e) {
        e.navigation.destroy();
      },
      "enable disable": function (e) {
        var t = e.navigation,
          i = t.$nextEl,
          r = t.$prevEl;
        i &&
          i[e.enabled ? "removeClass" : "addClass"](
            e.params.navigation.lockClass
          ),
          r &&
            r[e.enabled ? "removeClass" : "addClass"](
              e.params.navigation.lockClass
            );
      },
      click: function (e, t) {
        var i = e.navigation,
          r = i.$nextEl,
          n = i.$prevEl,
          a = t.target;
        if (e.params.navigation.hideOnClick && !g(a).is(n) && !g(a).is(r)) {
          if (
            e.pagination &&
            e.params.pagination &&
            e.params.pagination.clickable &&
            (e.pagination.el === a || e.pagination.el.contains(a))
          )
            return;
          var s;
          r
            ? (s = r.hasClass(e.params.navigation.hiddenClass))
            : n && (s = n.hasClass(e.params.navigation.hiddenClass)),
            !0 === s ? e.emit("navigationShow") : e.emit("navigationHide"),
            r && r.toggleClass(e.params.navigation.hiddenClass),
            n && n.toggleClass(e.params.navigation.hiddenClass);
        }
      },
    },
  };
  function ie() {
    return (
      (ie =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var r in i)
              Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
          }
          return e;
        }),
      ie.apply(this, arguments)
    );
  }
  var re = {
    update: function () {
      var e = this,
        t = e.rtl,
        i = e.params.pagination;
      if (
        i.el &&
        e.pagination.el &&
        e.pagination.$el &&
        0 !== e.pagination.$el.length
      ) {
        var r,
          n =
            e.virtual && e.params.virtual.enabled
              ? e.virtual.slides.length
              : e.slides.length,
          a = e.pagination.$el,
          s = e.params.loop
            ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup)
            : e.snapGrid.length;
        if (
          (e.params.loop
            ? ((r = Math.ceil(
                (e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup
              )) >
                n - 1 - 2 * e.loopedSlides && (r -= n - 2 * e.loopedSlides),
              r > s - 1 && (r -= s),
              r < 0 && "bullets" !== e.params.paginationType && (r = s + r))
            : (r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
          "bullets" === i.type &&
            e.pagination.bullets &&
            e.pagination.bullets.length > 0)
        ) {
          var o,
            l,
            d,
            u = e.pagination.bullets;
          if (
            (i.dynamicBullets &&
              ((e.pagination.bulletSize = u
                .eq(0)
                [e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
              a.css(
                e.isHorizontal() ? "width" : "height",
                e.pagination.bulletSize * (i.dynamicMainBullets + 4) + "px"
              ),
              i.dynamicMainBullets > 1 &&
                void 0 !== e.previousIndex &&
                ((e.pagination.dynamicBulletIndex += r - e.previousIndex),
                e.pagination.dynamicBulletIndex > i.dynamicMainBullets - 1
                  ? (e.pagination.dynamicBulletIndex = i.dynamicMainBullets - 1)
                  : e.pagination.dynamicBulletIndex < 0 &&
                    (e.pagination.dynamicBulletIndex = 0)),
              (o = r - e.pagination.dynamicBulletIndex),
              (d =
                ((l = o + (Math.min(u.length, i.dynamicMainBullets) - 1)) + o) /
                2)),
            u.removeClass(
              i.bulletActiveClass +
                " " +
                i.bulletActiveClass +
                "-next " +
                i.bulletActiveClass +
                "-next-next " +
                i.bulletActiveClass +
                "-prev " +
                i.bulletActiveClass +
                "-prev-prev " +
                i.bulletActiveClass +
                "-main"
            ),
            a.length > 1)
          )
            u.each(function (e) {
              var t = g(e),
                n = t.index();
              n === r && t.addClass(i.bulletActiveClass),
                i.dynamicBullets &&
                  (n >= o &&
                    n <= l &&
                    t.addClass(i.bulletActiveClass + "-main"),
                  n === o &&
                    t
                      .prev()
                      .addClass(i.bulletActiveClass + "-prev")
                      .prev()
                      .addClass(i.bulletActiveClass + "-prev-prev"),
                  n === l &&
                    t
                      .next()
                      .addClass(i.bulletActiveClass + "-next")
                      .next()
                      .addClass(i.bulletActiveClass + "-next-next"));
            });
          else {
            var p = u.eq(r),
              c = p.index();
            if ((p.addClass(i.bulletActiveClass), i.dynamicBullets)) {
              for (var v = u.eq(o), f = u.eq(l), h = o; h <= l; h += 1)
                u.eq(h).addClass(i.bulletActiveClass + "-main");
              if (e.params.loop)
                if (c >= u.length - i.dynamicMainBullets) {
                  for (var m = i.dynamicMainBullets; m >= 0; m -= 1)
                    u.eq(u.length - m).addClass(i.bulletActiveClass + "-main");
                  u.eq(u.length - i.dynamicMainBullets - 1).addClass(
                    i.bulletActiveClass + "-prev"
                  );
                } else
                  v
                    .prev()
                    .addClass(i.bulletActiveClass + "-prev")
                    .prev()
                    .addClass(i.bulletActiveClass + "-prev-prev"),
                    f
                      .next()
                      .addClass(i.bulletActiveClass + "-next")
                      .next()
                      .addClass(i.bulletActiveClass + "-next-next");
              else
                v
                  .prev()
                  .addClass(i.bulletActiveClass + "-prev")
                  .prev()
                  .addClass(i.bulletActiveClass + "-prev-prev"),
                  f
                    .next()
                    .addClass(i.bulletActiveClass + "-next")
                    .next()
                    .addClass(i.bulletActiveClass + "-next-next");
            }
          }
          if (i.dynamicBullets) {
            var w = Math.min(u.length, i.dynamicMainBullets + 4),
              b =
                (e.pagination.bulletSize * w - e.pagination.bulletSize) / 2 -
                d * e.pagination.bulletSize,
              y = t ? "right" : "left";
            u.css(e.isHorizontal() ? y : "top", b + "px");
          }
        }
        if (
          ("fraction" === i.type &&
            (a.find(S(i.currentClass)).text(i.formatFractionCurrent(r + 1)),
            a.find(S(i.totalClass)).text(i.formatFractionTotal(s))),
          "progressbar" === i.type)
        ) {
          var C;
          C = i.progressbarOpposite
            ? e.isHorizontal()
              ? "vertical"
              : "horizontal"
            : e.isHorizontal()
            ? "horizontal"
            : "vertical";
          var T = (r + 1) / s,
            E = 1,
            x = 1;
          "horizontal" === C ? (E = T) : (x = T),
            a
              .find(S(i.progressbarFillClass))
              .transform(
                "translate3d(0,0,0) scaleX(" + E + ") scaleY(" + x + ")"
              )
              .transition(e.params.speed);
        }
        "custom" === i.type && i.renderCustom
          ? (a.html(i.renderCustom(e, r + 1, s)),
            e.emit("paginationRender", a[0]))
          : e.emit("paginationUpdate", a[0]),
          e.params.watchOverflow &&
            e.enabled &&
            a[e.isLocked ? "addClass" : "removeClass"](i.lockClass);
      }
    },
    render: function () {
      var e = this,
        t = e.params.pagination;
      if (
        t.el &&
        e.pagination.el &&
        e.pagination.$el &&
        0 !== e.pagination.$el.length
      ) {
        var i =
            e.virtual && e.params.virtual.enabled
              ? e.virtual.slides.length
              : e.slides.length,
          r = e.pagination.$el,
          n = "";
        if ("bullets" === t.type) {
          var a = e.params.loop
            ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup)
            : e.snapGrid.length;
          e.params.freeMode && !e.params.loop && a > i && (a = i);
          for (var s = 0; s < a; s += 1)
            t.renderBullet
              ? (n += t.renderBullet.call(e, s, t.bulletClass))
              : (n +=
                  "<" +
                  t.bulletElement +
                  ' class="' +
                  t.bulletClass +
                  '"></' +
                  t.bulletElement +
                  ">");
          r.html(n), (e.pagination.bullets = r.find(S(t.bulletClass)));
        }
        "fraction" === t.type &&
          ((n = t.renderFraction
            ? t.renderFraction.call(e, t.currentClass, t.totalClass)
            : '<span class="' +
              t.currentClass +
              '"></span> / <span class="' +
              t.totalClass +
              '"></span>'),
          r.html(n)),
          "progressbar" === t.type &&
            ((n = t.renderProgressbar
              ? t.renderProgressbar.call(e, t.progressbarFillClass)
              : '<span class="' + t.progressbarFillClass + '"></span>'),
            r.html(n)),
          "custom" !== t.type &&
            e.emit("paginationRender", e.pagination.$el[0]);
      }
    },
    init: function () {
      var e = this;
      e.params.pagination = E(
        e.$el,
        e.params.pagination,
        e.params.createElements,
        { el: "swiper-pagination" }
      );
      var t = e.params.pagination;
      if (t.el) {
        var i = g(t.el);
        0 !== i.length &&
          (e.params.uniqueNavElements &&
            "string" == typeof t.el &&
            i.length > 1 &&
            (i = e.$el.find(t.el)),
          "bullets" === t.type && t.clickable && i.addClass(t.clickableClass),
          i.addClass(t.modifierClass + t.type),
          "bullets" === t.type &&
            t.dynamicBullets &&
            (i.addClass("" + t.modifierClass + t.type + "-dynamic"),
            (e.pagination.dynamicBulletIndex = 0),
            t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
          "progressbar" === t.type &&
            t.progressbarOpposite &&
            i.addClass(t.progressbarOppositeClass),
          t.clickable &&
            i.on("click", S(t.bulletClass), function (t) {
              t.preventDefault();
              var i = g(this).index() * e.params.slidesPerGroup;
              e.params.loop && (i += e.loopedSlides), e.slideTo(i);
            }),
          C(e.pagination, { $el: i, el: i[0] }),
          e.enabled || i.addClass(t.lockClass));
      }
    },
    destroy: function () {
      var e = this,
        t = e.params.pagination;
      if (
        t.el &&
        e.pagination.el &&
        e.pagination.$el &&
        0 !== e.pagination.$el.length
      ) {
        var i = e.pagination.$el;
        i.removeClass(t.hiddenClass),
          i.removeClass(t.modifierClass + t.type),
          e.pagination.bullets &&
            e.pagination.bullets.removeClass(t.bulletActiveClass),
          t.clickable && i.off("click", S(t.bulletClass));
      }
    },
  };
  const ne = {
    name: "pagination",
    params: {
      pagination: {
        el: null,
        bulletElement: "span",
        clickable: !1,
        hideOnClick: !1,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: !1,
        type: "bullets",
        dynamicBullets: !1,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (e) {
          return e;
        },
        formatFractionTotal: function (e) {
          return e;
        },
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active",
        modifierClass: "swiper-pagination-",
        currentClass: "swiper-pagination-current",
        totalClass: "swiper-pagination-total",
        hiddenClass: "swiper-pagination-hidden",
        progressbarFillClass: "swiper-pagination-progressbar-fill",
        progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
        clickableClass: "swiper-pagination-clickable",
        lockClass: "swiper-pagination-lock",
      },
    },
    create: function () {
      T(this, { pagination: ie({ dynamicBulletIndex: 0 }, re) });
    },
    on: {
      init: function (e) {
        e.pagination.init(), e.pagination.render(), e.pagination.update();
      },
      activeIndexChange: function (e) {
        (e.params.loop || void 0 === e.snapIndex) && e.pagination.update();
      },
      snapIndexChange: function (e) {
        e.params.loop || e.pagination.update();
      },
      slidesLengthChange: function (e) {
        e.params.loop && (e.pagination.render(), e.pagination.update());
      },
      snapGridLengthChange: function (e) {
        e.params.loop || (e.pagination.render(), e.pagination.update());
      },
      destroy: function (e) {
        e.pagination.destroy();
      },
      "enable disable": function (e) {
        var t = e.pagination.$el;
        t &&
          t[e.enabled ? "removeClass" : "addClass"](
            e.params.pagination.lockClass
          );
      },
      click: function (e, t) {
        var i = t.target;
        if (
          e.params.pagination.el &&
          e.params.pagination.hideOnClick &&
          e.pagination.$el.length > 0 &&
          !g(i).hasClass(e.params.pagination.bulletClass)
        ) {
          if (
            e.navigation &&
            ((e.navigation.nextEl && i === e.navigation.nextEl) ||
              (e.navigation.prevEl && i === e.navigation.prevEl))
          )
            return;
          !0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass)
            ? e.emit("paginationShow")
            : e.emit("paginationHide"),
            e.pagination.$el.toggleClass(e.params.pagination.hiddenClass);
        }
      },
    },
  };
  function ae() {
    return (
      (ae =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var r in i)
              Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
          }
          return e;
        }),
      ae.apply(this, arguments)
    );
  }
  var se = {
    run: function () {
      var e = this,
        t = e.slides.eq(e.activeIndex),
        i = e.params.autoplay.delay;
      t.attr("data-swiper-autoplay") &&
        (i = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
        clearTimeout(e.autoplay.timeout),
        (e.autoplay.timeout = w(function () {
          var t;
          e.params.autoplay.reverseDirection
            ? e.params.loop
              ? (e.loopFix(),
                (t = e.slidePrev(e.params.speed, !0, !0)),
                e.emit("autoplay"))
              : e.isBeginning
              ? e.params.autoplay.stopOnLastSlide
                ? e.autoplay.stop()
                : ((t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0)),
                  e.emit("autoplay"))
              : ((t = e.slidePrev(e.params.speed, !0, !0)), e.emit("autoplay"))
            : e.params.loop
            ? (e.loopFix(),
              (t = e.slideNext(e.params.speed, !0, !0)),
              e.emit("autoplay"))
            : e.isEnd
            ? e.params.autoplay.stopOnLastSlide
              ? e.autoplay.stop()
              : ((t = e.slideTo(0, e.params.speed, !0, !0)), e.emit("autoplay"))
            : ((t = e.slideNext(e.params.speed, !0, !0)), e.emit("autoplay")),
            ((e.params.cssMode && e.autoplay.running) || !1 === t) &&
              e.autoplay.run();
        }, i));
    },
    start: function () {
      var e = this;
      return (
        void 0 === e.autoplay.timeout &&
        !e.autoplay.running &&
        ((e.autoplay.running = !0),
        e.emit("autoplayStart"),
        e.autoplay.run(),
        !0)
      );
    },
    stop: function () {
      var e = this;
      return (
        !!e.autoplay.running &&
        void 0 !== e.autoplay.timeout &&
        (e.autoplay.timeout &&
          (clearTimeout(e.autoplay.timeout), (e.autoplay.timeout = void 0)),
        (e.autoplay.running = !1),
        e.emit("autoplayStop"),
        !0)
      );
    },
    pause: function (e) {
      var t = this;
      t.autoplay.running &&
        (t.autoplay.paused ||
          (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
          (t.autoplay.paused = !0),
          0 !== e && t.params.autoplay.waitForTransition
            ? ["transitionend", "webkitTransitionEnd"].forEach(function (e) {
                t.$wrapperEl[0].addEventListener(e, t.autoplay.onTransitionEnd);
              })
            : ((t.autoplay.paused = !1), t.autoplay.run())));
    },
    onVisibilityChange: function () {
      var e = this,
        t = r();
      "hidden" === t.visibilityState &&
        e.autoplay.running &&
        e.autoplay.pause(),
        "visible" === t.visibilityState &&
          e.autoplay.paused &&
          (e.autoplay.run(), (e.autoplay.paused = !1));
    },
    onTransitionEnd: function (e) {
      var t = this;
      t &&
        !t.destroyed &&
        t.$wrapperEl &&
        e.target === t.$wrapperEl[0] &&
        (["transitionend", "webkitTransitionEnd"].forEach(function (e) {
          t.$wrapperEl[0].removeEventListener(e, t.autoplay.onTransitionEnd);
        }),
        (t.autoplay.paused = !1),
        t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
    },
    onMouseEnter: function () {
      var e = this;
      e.params.autoplay.disableOnInteraction
        ? e.autoplay.stop()
        : e.autoplay.pause(),
        ["transitionend", "webkitTransitionEnd"].forEach(function (t) {
          e.$wrapperEl[0].removeEventListener(t, e.autoplay.onTransitionEnd);
        });
    },
    onMouseLeave: function () {
      var e = this;
      e.params.autoplay.disableOnInteraction ||
        ((e.autoplay.paused = !1), e.autoplay.run());
    },
    attachMouseEvents: function () {
      var e = this;
      e.params.autoplay.pauseOnMouseEnter &&
        (e.$el.on("mouseenter", e.autoplay.onMouseEnter),
        e.$el.on("mouseleave", e.autoplay.onMouseLeave));
    },
    detachMouseEvents: function () {
      var e = this;
      e.$el.off("mouseenter", e.autoplay.onMouseEnter),
        e.$el.off("mouseleave", e.autoplay.onMouseLeave);
    },
  };
  const oe = {
    name: "autoplay",
    params: {
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !0,
        stopOnLastSlide: !1,
        reverseDirection: !1,
        pauseOnMouseEnter: !1,
      },
    },
    create: function () {
      T(this, { autoplay: ae({}, se, { running: !1, paused: !1 }) });
    },
    on: {
      init: function (e) {
        e.params.autoplay.enabled &&
          (e.autoplay.start(),
          r().addEventListener(
            "visibilitychange",
            e.autoplay.onVisibilityChange
          ),
          e.autoplay.attachMouseEvents());
      },
      beforeTransitionStart: function (e, t, i) {
        e.autoplay.running &&
          (i || !e.params.autoplay.disableOnInteraction
            ? e.autoplay.pause(t)
            : e.autoplay.stop());
      },
      sliderFirstMove: function (e) {
        e.autoplay.running &&
          (e.params.autoplay.disableOnInteraction
            ? e.autoplay.stop()
            : e.autoplay.pause());
      },
      touchEnd: function (e) {
        e.params.cssMode &&
          e.autoplay.paused &&
          !e.params.autoplay.disableOnInteraction &&
          e.autoplay.run();
      },
      destroy: function (e) {
        e.autoplay.detachMouseEvents(),
          e.autoplay.running && e.autoplay.stop(),
          r().removeEventListener(
            "visibilitychange",
            e.autoplay.onVisibilityChange
          );
      },
    },
  };
  function le(e, t) {
    document.querySelector(t).addEventListener("mouseenter", function () {
      e.autoplay.stop();
    }),
      document.querySelector(t).addEventListener("mouseleave", function () {
        e.autoplay.start();
      });
  }
  if (
    (Q.use([te, ne, oe]),
    document.querySelector(".best-seller__slider") &&
      new Q(".best-seller__slider", {
        cssMode: !0,
        slidesPerView: 2.33,
        spaceBetween: 24,
        navigation: {
          nextEl: ".swiper-button-next.best-seller__next",
          prevEl: ".swiper-button-prev.best-seller__prev",
        },
        breakpoints: {
          320: { slidesPerView: 1.25, spaceBetween: 16 },
          480: { slidesPerView: 1.7, spaceBetween: 20 },
          990: { slidesPerView: 2.33, spaceBetween: 24 },
        },
      }),
    document.querySelector(".featured-collection__slider") &&
      new Q(".featured-collection__slider", {
        cssMode: !0,
        slidesPerView: 4,
        spaceBetween: 24,
        navigation: {
          nextEl: ".swiper-button-next.featured-collection__next",
          prevEl: ".swiper-button-prev.featured-collection__prev",
        },
        breakpoints: {
          320: { slidesPerView: 1.25, spaceBetween: 16 },
          480: { slidesPerView: 2.5, spaceBetween: 20 },
          990: { slidesPerView: 4, spaceBetween: 24 },
        },
      }),
    document.querySelector(".review-slider__slider") &&
      le(
        new Q(".review-slider__slider", {
          spaceBetween: 30,
          centeredSlides: !0,
          slidesPerView: 1,
          loop: !0,
          autoplay: { delay: 5e3, disableOnInteraction: !1 },
          navigation: {
            nextEl: ".swiper-button-next.review-slider__next",
            prevEl: ".swiper-button-prev.review-slider__prev",
          },
        }),
        ".review-slider__slider"
      ),
    document.querySelector(".product-gallery__slider"))
  ) {
    (window.product_thumbnails_slider = new Q(".product-gallery__thumbnails", {
      spaceBetween: 24,
      slidesPerView: 6,
      slidesPerGroup: 1,
      direction: "vertical",
      slideToClickedSlide: !0,
    })),
      (window.product_gallery_slider = new Q(".product-gallery__main-images", {
        spaceBetween: 16,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          clickable: !0,
        },
        thumbs: { swiper: product_thumbnails_slider },
        breakpoints: {
          320: { direction: "horizontal", slidesPerView: "auto" },
          990: { direction: "vertical", slidesPerView: "auto" },
        },
      })),
      product_thumbnails_slider.on("slideChange", function (e) {
        product_gallery_slider.slideTo(
          product_thumbnails_slider.activeIndex,
          200
        );
      }),
      product_gallery_slider.on("slideChange", function (e) {
        product_thumbnails_slider.slideTo(
          product_gallery_slider.activeIndex,
          200
        );
      });
    const e = () => {
      window.matchMedia("(max-width: 990px)").matches
        ? (product_thumbnails_slider.destroy(),
          (document.querySelector(
            ".product-gallery__thumbnails"
          ).style.display = "none"))
        : ((document.querySelector(
            ".product-gallery__thumbnails"
          ).style.display = "block"),
          product_thumbnails_slider.init(),
          product_thumbnails_slider.update());
    };
    window.addEventListener("resize", e);
  }
  if (
    (document.querySelector(".partner__slider-swiper") &&
      new Q(".partner__slider-swiper", {
        slidesPerView: 4.2,
        spaceBetween: 128,
        initialSlide: 2,
        centeredSlides: !0,
        loop: !0,
        speed: 600,
        breakpoints: {
          320: { spaceBetween: 13, slidesPerView: 1.5 },
          768: { spaceBetween: 50, slidesPerView: 2.5 },
          1300: { spaceBetween: 128, slidesPerView: 4.2 },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          clickable: !0,
        },
      }),
    document.querySelector(".gallery-slider__content"))
  ) {
    var de = {};
    if (document.querySelector(".template-product")) {
      const e = document.querySelectorAll(".gallery-slider .swiper-slide"),
        t = document.querySelector(".gallery-slider .gallery-slider__content"),
        i = document.querySelector(".gallery-slider .swiper-wrapper");
      e.length < 7
        ? (i && i.classList.add("initial-timing"),
          t && t.classList.add("max-width"),
          (de = {
            spaceBetween: 30,
            slidesPerView: 6,
            speed: 650,
            initialSlide: 0,
            breakpoints: {
              320: {
                slidesPerView: 2.5,
                spaceBetween: 30,
                centeredSlides: !0,
                freeMode: !0,
                initialSlide: 1,
              },
              600: {
                slidesPerView: 3.5,
                spaceBetween: 30,
                centeredSlides: !1,
                freeMode: !1,
                initialSlide: 0,
              },
              1025: { slidesPerView: 5 },
              1300: { slidesPerView: 6 },
            },
          }))
        : (de = {
            spaceBetween: 30,
            centeredSlides: !0,
            speed: 5e3,
            autoplay: { delay: 1 },
            loop: !0,
            loopedSlides: 7,
            slidesPerView: 7,
            allowTouchMove: !1,
            observer: !0,
            observeParents: !0,
            breakpoints: {
              320: {
                slidesPerView: 2.5,
                spaceBetween: 30,
                centeredSlides: !0,
                freeMode: !0,
                initialSlide: 1,
                speed: 500,
                autoplay: !1,
                allowTouchMove: !0,
                loop: !1,
              },
              600: {
                slidesPerView: 3.5,
                spaceBetween: 30,
                centeredSlides: !1,
                freeMode: !1,
                initialSlide: 0,
              },
              767: {
                speed: 5e3,
                allowTouchMove: !1,
                loop: !0,
                autoplay: { delay: 1 },
              },
              1025: { slidesPerView: 5 },
              1300: { slidesPerView: 6 },
            },
          });
    } else
      de = {
        spaceBetween: 30,
        slidesPerView: 6.5,
        centeredSlides: !0,
        speed: 5e3,
        autoplay: { delay: 0 },
        loop: !0,
        loopedSlides: 5,
        allowTouchMove: !0,
        disableOnInteraction: !0,
        breakpoints: {
          320: { slidesPerView: 2.5, spaceBetween: 60, allowTouchMove: !0 },
          600: { slidesPerView: 3.5, spaceBetween: 30, allowTouchMove: !0 },
          1025: { slidesPerView: 5, allowTouchMove: !1 },
          1300: { slidesPerView: 6.5, allowTouchMove: !1 },
        },
      };
    new Q(".gallery-slider__content", de),
      le(
        document.querySelector(".gallery-slider__content").swiper,
        ".gallery-slider__content"
      );
  }
  document.querySelector(".brag-bar__slider") &&
    (new Q(".brag-bar__slider", {
      spaceBetween: 0,
      centeredSlides: !0,
      speed: 5e3,
      autoplay: { delay: 1 },
      navigation: {
        nextEl: ".swiper-button-next.brag-bar__next",
        prevEl: ".swiper-button-prev.brag-bar__prev",
        clickable: !0,
      },
      loop: !0,
      loopedSlides: 4,
      slidesPerView: "auto",
      allowTouchMove: !0,
      observer: !0,
      observeParents: !0,
      breakpoints: {
        320: { speed: 500, autoplay: !1 },
        767: { speed: 5e3, autoplay: { delay: 1 } },
      },
    }),
    le(
      document.querySelector(".brag-bar__slider").swiper,
      ".brag-bar__slider"
    )),
    document.querySelector(".our-team__slide") &&
      new Q(".our-team__slider", {
        spaceBetween: 24,
        slidesPerView: 4,
        cssMode: !0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        mousewheel: !0,
        keyboard: !0,
        breakpoints: {
          320: { spaceBetween: 16, slidesPerView: 1.25 },
          490: { spaceBetween: 16, slidesPerView: 2 },
          990: { spaceBetween: 24, slidesPerView: 4 },
        },
      });
})();
